(() => {
  'use strict';

  if (window.__BT_SEARCH_ENGINE_LOADED__) return;
  window.__BT_SEARCH_ENGINE_LOADED__ = true;

  const CACHE_VERSION = 'bt-search-v1.7.1';
  const B2B_CACHE_FRESH_TTL_MS = 30 * 60 * 1000;
  const B2B_CACHE_STALE_TTL_MS = 2 * 60 * 60 * 1000;
  const B2B_CONTEXT_SECTION_ID = 'bt-search-buyer-context';
  const B2B_INDEX_SECTION_ID = 'bt-search-b2b-index';
  const B2B_INDEX_CONCURRENCY = 4;
  const CACHE_FRESH_TTL_MS = 60 * 60 * 1000;
  const CACHE_STALE_TTL_MS = 24 * 60 * 60 * 1000;
  const DEFAULT_API_VERSION = '2026-07';

  const COLLECTION_MATCH_WEIGHT = 65;
  const COLLECTION_SEARCH_TERM_WEIGHT = 110;
  const BEST_SELLING_TIE_THRESHOLD = 5;

  const IDB_NAME = 'bt-search-cache';
  const IDB_VERSION = 1;
  const IDB_STORE = 'indexes';

  let IDB_PROMISE = null;

  const GLOBAL_INFLIGHT =
    window.__BT_SEARCH_INFLIGHT__ ||
    new Map();

  const GLOBAL_BACKGROUND_REFRESHES =
    window.__BT_SEARCH_BACKGROUND_REFRESHES__ ||
    new Map();

  const GLOBAL_DICTIONARY_PROMISES =
    window.__BT_SEARCH_DICTIONARY_PROMISES__ ||
    new Map();

  const GLOBAL_BUYER_CONTEXT_PROMISES =
    window.__BT_SEARCH_BUYER_CONTEXT_PROMISES__ ||
    new Map();

  window.__BT_SEARCH_INFLIGHT__ =
    GLOBAL_INFLIGHT;

  window.__BT_SEARCH_BACKGROUND_REFRESHES__ =
    GLOBAL_BACKGROUND_REFRESHES;

  window.__BT_SEARCH_DICTIONARY_PROMISES__ =
    GLOBAL_DICTIONARY_PROMISES;


  window.__BT_SEARCH_BUYER_CONTEXT_PROMISES__ =
    GLOBAL_BUYER_CONTEXT_PROMISES;


  /* =========================================================
     ORDENACIÓN
     ========================================================= */

  const SORT_OPTIONS = [
    {
      value: 'relevance',
      label: 'Relevancia'
    },
    {
      value: 'best-selling',
      label: 'Más vendidos'
    },
    {
      value: 'price-asc',
      label: 'Precio: menor a mayor'
    },
    {
      value: 'price-desc',
      label: 'Precio: mayor a menor'
    },
    {
      value: 'title-asc',
      label: 'Nombre: A–Z'
    }
  ];


  /* =========================================================
     FILTROS
     ========================================================= */

  const FILTER_DEFS = [
    {
      key: 'vendor',
      label: 'Marca',
      mode: 'or',
      searchable: true
    },
    {
      key: 'formato',
      label: 'Formato',
      mode: 'or'
    },
    {
      key: 'alergenos',
      label: 'Alérgenos e intolerancias',
      mode: 'and'
    },
    {
      key: 'preferencias',
      label: 'Preferencias',
      mode: 'and'
    },
    {
      key: 'sostenibilidad',
      label: 'Sostenibilidad',
      mode: 'and'
    },
    {
      key: 'etapaVital',
      label: 'Etapa vital',
      mode: 'and'
    }
  ];


  /* =========================================================
     RANKING
     ========================================================= */

  const STOPWORDS_BY_LANGUAGE = {

    es:
      new Set([
        'a',
        'al',
        'algo',
        'con',
        'de',
        'del',
        'el',
        'en',
        'la',
        'las',
        'lo',
        'los',
        'o',
        'para',
        'por',
        'que',
        'se',
        'sin',
        'su',
        'sus',
        'un',
        'una',
        'unos',
        'unas',
        'y'
      ]),

    en:
      new Set([
        'a',
        'an',
        'and',
        'are',
        'for',
        'from',
        'in',
        'is',
        'of',
        'on',
        'or',
        'the',
        'to',
        'with',
        'without'
      ]),

    de:
      new Set([
        'aber',
        'als',
        'am',
        'an',
        'auch',
        'auf',
        'aus',
        'bei',
        'das',
        'dem',
        'den',
        'der',
        'des',
        'die',
        'ein',
        'eine',
        'einem',
        'einen',
        'einer',
        'eines',
        'fur',
        'im',
        'in',
        'ist',
        'mit',
        'oder',
        'ohne',
        'und',
        'von',
        'vor',
        'zu',
        'zum',
        'zur'
      ])

  };


  const UI_COPY = {

    es: {
      sortRelevance: 'Relevancia',
      sortBestSelling: 'Más vendidos',
      sortPriceAsc: 'Precio: menor a mayor',
      sortPriceDesc: 'Precio: mayor a menor',
      sortTitleAsc: 'Nombre: A–Z',

      filterVendor: 'Marca',
      filterFormat: 'Formato',
      filterAllergens: 'Alérgenos e intolerancias',
      filterPreferences: 'Preferencias',
      filterSustainability: 'Sostenibilidad',
      filterLifeStage: 'Etapa vital',

      sortBy: 'Ordenar por',
      filter: 'Filtrar',
      filterBy: 'Filtrar por',
      clearFilters: 'Limpiar filtros',
      searchBrand: 'Buscar marca',
      noOptions: 'No hay opciones disponibles.',
      from: 'Desde',
      to: 'Hasta',
      availableRange: 'Rango disponible',
      price: 'Precio',
      priceFrom: 'Precio: desde',
      priceTo: 'Precio: hasta',
      filters: 'Filtros',
      closeFilters: 'Cerrar filtros',
      view: 'Ver',

      resultSingular: 'resultado',
      resultPlural: 'resultados',
      forWord: 'para',

      collections: 'Colecciones',
      products: 'Productos',
      show: 'Mostrar',
      soldOut: 'Agotado',
      relatedCollections: 'Colecciones relacionadas',

      noPredictiveResults: 'No hemos encontrado resultados para',
      noProductsFor: 'No hemos encontrado productos para',
      tryGeneralSearch: 'Prueba con el ingrediente, la marca, el tipo de producto o una necesidad más general.',
      noFilteredProducts: 'No hay productos con los filtros seleccionados.',
      tryRemoveFilters: 'Prueba a quitar uno o varios filtros.',

      addToCart: 'Añadir al carrito',
      adding: 'Añadiendo…',
      added: 'Añadido ✓',
      addError: 'Error al añadir',
      addFailed: 'No se pudo añadir al carrito.',

      reviewSingular: 'reseña',
      reviewPlural: 'reseñas',
      outOfFive: 'de 5',
      perDose: 'dosis',

      previous: 'Anterior',
      next: 'Siguiente',
      previousPage: 'Ir a la página anterior',
      nextPage: 'Ir a la página siguiente',
      goToPage: 'Ir a la página',

      initialPrompt: 'Busca por producto, ingrediente, marca o necesidad.',
      examples: 'Ejemplos',
      exampleTerms: 'magnesio, bisglicinato, Saccharomyces, DAO, sueño, digestión…',

      loadingIndex: 'Cargando índice…',
      readyUpdating: 'Buscador listo · actualizando en segundo plano.',
      ready: 'Buscador listo.',
      indexUpdated: 'Índice actualizado.',
      backgroundUpdated: 'Buscador actualizado en segundo plano.',
      configError: 'Error de configuración',
      startupFailed: 'No se pudo iniciar el buscador.',
      checkToken: 'Comprueba el token público de Storefront.',
      checkMetafields: 'Comprueba el acceso Storefront de los metafields.'
    },

    en: {
      sortRelevance: 'Relevance',
      sortBestSelling: 'Best selling',
      sortPriceAsc: 'Price: low to high',
      sortPriceDesc: 'Price: high to low',
      sortTitleAsc: 'Name: A–Z',

      filterVendor: 'Brand',
      filterFormat: 'Format',
      filterAllergens: 'Allergens and intolerances',
      filterPreferences: 'Preferences',
      filterSustainability: 'Sustainability',
      filterLifeStage: 'Life stage',

      sortBy: 'Sort by',
      filter: 'Filter',
      filterBy: 'Filter by',
      clearFilters: 'Clear filters',
      searchBrand: 'Search brand',
      noOptions: 'No options available.',
      from: 'From',
      to: 'To',
      availableRange: 'Available range',
      price: 'Price',
      priceFrom: 'Price: from',
      priceTo: 'Price: up to',
      filters: 'Filters',
      closeFilters: 'Close filters',
      view: 'View',

      resultSingular: 'result',
      resultPlural: 'results',
      forWord: 'for',

      collections: 'Collections',
      products: 'Products',
      show: 'Show',
      soldOut: 'Sold out',
      relatedCollections: 'Related collections',

      noPredictiveResults: 'No results found for',
      noProductsFor: 'No products found for',
      tryGeneralSearch: 'Try searching by ingredient, brand, product type, or a more general need.',
      noFilteredProducts: 'No products match the selected filters.',
      tryRemoveFilters: 'Try removing one or more filters.',

      addToCart: 'Add to cart',
      adding: 'Adding…',
      added: 'Added ✓',
      addError: 'Error adding',
      addFailed: 'Could not add to cart.',

      reviewSingular: 'review',
      reviewPlural: 'reviews',
      outOfFive: 'out of 5',
      perDose: 'dose',

      previous: 'Previous',
      next: 'Next',
      previousPage: 'Go to previous page',
      nextPage: 'Go to next page',
      goToPage: 'Go to page',

      initialPrompt: 'Search by product, ingredient, brand, or need.',
      examples: 'Examples',
      exampleTerms: 'magnesium, bisglycinate, Saccharomyces, DAO, sleep, digestion…',

      loadingIndex: 'Loading search index…',
      readyUpdating: 'Search ready · updating in the background.',
      ready: 'Search ready.',
      indexUpdated: 'Search index updated.',
      backgroundUpdated: 'Search updated in the background.',
      configError: 'Configuration error',
      startupFailed: 'Search could not be started.',
      checkToken: 'Check the public Storefront token.',
      checkMetafields: 'Check Storefront access for the metafields.'
    },

    de: {
      sortRelevance: 'Relevanz',
      sortBestSelling: 'Meistverkauft',
      sortPriceAsc: 'Preis: aufsteigend',
      sortPriceDesc: 'Preis: absteigend',
      sortTitleAsc: 'Name: A–Z',

      filterVendor: 'Marke',
      filterFormat: 'Format',
      filterAllergens: 'Allergene und Unverträglichkeiten',
      filterPreferences: 'Präferenzen',
      filterSustainability: 'Nachhaltigkeit',
      filterLifeStage: 'Lebensphase',

      sortBy: 'Sortieren nach',
      filter: 'Filtern',
      filterBy: 'Filtern nach',
      clearFilters: 'Filter löschen',
      searchBrand: 'Marke suchen',
      noOptions: 'Keine Optionen verfügbar.',
      from: 'Von',
      to: 'Bis',
      availableRange: 'Verfügbarer Bereich',
      price: 'Preis',
      priceFrom: 'Preis: ab',
      priceTo: 'Preis: bis',
      filters: 'Filter',
      closeFilters: 'Filter schließen',
      view: 'Ansehen',

      resultSingular: 'Ergebnis',
      resultPlural: 'Ergebnisse',
      forWord: 'für',

      collections: 'Kollektionen',
      products: 'Produkte',
      show: 'Zeige',
      soldOut: 'Ausverkauft',
      relatedCollections: 'Passende Kollektionen',

      noPredictiveResults: 'Keine Ergebnisse gefunden für',
      noProductsFor: 'Keine Produkte gefunden für',
      tryGeneralSearch: 'Suche nach Inhaltsstoff, Marke, Produkttyp oder einem allgemeineren Bedarf.',
      noFilteredProducts: 'Keine Produkte entsprechen den ausgewählten Filtern.',
      tryRemoveFilters: 'Entferne einen oder mehrere Filter.',

      addToCart: 'In den Warenkorb',
      adding: 'Wird hinzugefügt…',
      added: 'Hinzugefügt ✓',
      addError: 'Fehler beim Hinzufügen',
      addFailed: 'Produkt konnte nicht zum Warenkorb hinzugefügt werden.',

      reviewSingular: 'Bewertung',
      reviewPlural: 'Bewertungen',
      outOfFive: 'von 5',
      perDose: 'Dosis',

      previous: 'Zurück',
      next: 'Weiter',
      previousPage: 'Zur vorherigen Seite',
      nextPage: 'Zur nächsten Seite',
      goToPage: 'Zur Seite',

      initialPrompt: 'Suche nach Produkt, Inhaltsstoff, Marke oder Bedarf.',
      examples: 'Beispiele',
      exampleTerms: 'Magnesium, Bisglycinat, Saccharomyces, DAO, Schlaf, Verdauung…',

      loadingIndex: 'Suchindex wird geladen…',
      readyUpdating: 'Suche bereit · Aktualisierung im Hintergrund.',
      ready: 'Suche bereit.',
      indexUpdated: 'Suchindex aktualisiert.',
      backgroundUpdated: 'Suche im Hintergrund aktualisiert.',
      configError: 'Konfigurationsfehler',
      startupFailed: 'Die Suche konnte nicht gestartet werden.',
      checkToken: 'Prüfe den öffentlichen Storefront-Token.',
      checkMetafields: 'Prüfe den Storefront-Zugriff auf die Metafelder.'
    }

  };


  function localeLanguageKey(locale) {

    const normalized =
      String(
        locale ||
        'es'
      )
        .trim()
        .toLowerCase()
        .replace(
          /_/g,
          '-'
        );

    const base =
      normalized
        .split('-')[0];

    return (
      base === 'de'
        ? 'de'
        : base === 'en'
          ? 'en'
          : 'es'
    );
  }


  function storefrontLanguageCode(locale) {

    const normalized =
      String(
        locale ||
        'es'
      )
        .trim()
        .replace(
          /-/g,
          '_'
        )
        .toUpperCase();

    if (
      normalized ===
        'PT_BR'
      ||
      normalized ===
        'PT_PT'
      ||
      normalized ===
        'ZH_CN'
      ||
      normalized ===
        'ZH_TW'
    ) {
      return normalized;
    }

    return (
      normalized
        .split('_')[0]
      ||
      'ES'
    );
  }


  function collatorLocale(locale) {

    const language =
      localeLanguageKey(
        locale
      );

    return language;
  }


  function stopwordsForLocale(locale) {

    const language =
      localeLanguageKey(
        locale
      );

    return (
      STOPWORDS_BY_LANGUAGE[
        language
      ]
      ||
      STOPWORDS_BY_LANGUAGE.es
    );
  }


  function uiCopyForLocale(locale) {

    const language =
      localeLanguageKey(
        locale
      );

    return (
      UI_COPY[language]
      ||
      UI_COPY.es
    );
  }


  /* =========================================================
     DICCIONARIO POR IDIOMA
     =========================================================

     Reglas de aislamiento:

     - ES conserva exactamente los grupos que utilizaba el motor
       antes de incorporar locale_extensions.
     - EN puede utilizar los grupos de intención del diccionario
       actual, sin tocar los alias españoles.
     - DE añade exclusivamente locale_extensions.de sobre una
       copia de los grupos base. Nunca muta el JSON compartido.
     ========================================================= */

  function localeDictionaryGroups(
    dictionary,
    locale
  ) {

    const source =
      dictionary ||
      {};

    const language =
      localeLanguageKey(
        locale
      );

    const baseSynonymGroups =
      Array.isArray(
        source.synonym_groups
      )
        ? source.synonym_groups
        : [];

    /*
     * Compatibilidad con el nombre que utilizaba históricamente
     * el motor. Mantener esta rama para ES evita modificar su
     * comportamiento actual.
     */
    const legacyIntentGroups =
      Array.isArray(
        source
          .intent_groups_not_bidirectional_synonyms
      )
        ? source
            .intent_groups_not_bidirectional_synonyms
        : [];

    if (language === 'es') {

      return {
        synonymGroups:
          baseSynonymGroups,

        intentGroups:
          legacyIntentGroups
      };
    }

    /*
     * El diccionario actual denomina estos grupos
     * intent_groups_not_synonyms. Para EN/DE aceptamos ambos
     * nombres, priorizando el histórico si alguna versión futura
     * vuelve a incluirlo.
     */
    const currentIntentGroups =
      legacyIntentGroups.length
        ? legacyIntentGroups
        : Array.isArray(
            source
              .intent_groups_not_synonyms
          )
          ? source
              .intent_groups_not_synonyms
          : [];

    if (language !== 'de') {

      return {
        synonymGroups:
          baseSynonymGroups,

        intentGroups:
          currentIntentGroups
      };
    }

    const extension =
      source
        .locale_extensions
        ?.de;

    if (!extension) {

      return {
        synonymGroups:
          baseSynonymGroups,

        intentGroups:
          currentIntentGroups
      };
    }

    const synonymAliases =
      extension
        .synonym_aliases
      ||
      {};

    const directionalAliases =
      extension
        .directional_query_aliases
      ||
      {};

    const intentTerms =
      extension
        .intent_terms
      ||
      {};

    const synonymGroups =
      baseSynonymGroups
        .map(
          group => {

            const canonical =
              String(
                group
                  ?.canonical
                ||
                ''
              );

            const extraAliases =
              Array.isArray(
                synonymAliases[canonical]
              )
                ? synonymAliases[canonical]
                : [];

            const extraDirectional =
              Array.isArray(
                directionalAliases[canonical]
              )
                ? directionalAliases[canonical]
                : [];

            if (
              !extraAliases.length &&
              !extraDirectional.length
            ) {
              return group;
            }

            return {
              ...group,

              aliases:
                unique([
                  ...(
                    group.aliases ||
                    []
                  ),
                  ...extraAliases
                ]),

              query_aliases:
                unique([
                  ...(
                    group.query_aliases ||
                    []
                  ),
                  ...extraDirectional
                ])
            };
          }
        );

    const localizedIntentGroups =
      currentIntentGroups
        .map(
          group => {

            const canonical =
              String(
                group
                  ?.canonical
                ||
                ''
              );

            const extraTerms =
              Array.isArray(
                intentTerms[canonical]
              )
                ? intentTerms[canonical]
                : [];

            if (!extraTerms.length) {
              return group;
            }

            return {
              ...group,

              terms:
                unique([
                  ...(
                    group.terms ||
                    []
                  ),
                  ...extraTerms
                ])
            };
          }
        );

    return {
      synonymGroups,
      intentGroups:
        localizedIntentGroups
    };
  }


  function applyUiDefinitionLabels(locale) {

    const ui =
      uiCopyForLocale(
        locale
      );

    const sortLabels = {
      relevance:
        ui.sortRelevance,
      'best-selling':
        ui.sortBestSelling,
      'price-asc':
        ui.sortPriceAsc,
      'price-desc':
        ui.sortPriceDesc,
      'title-asc':
        ui.sortTitleAsc
    };

    SORT_OPTIONS.forEach(
      option => {

        option.label =
          sortLabels[
            option.value
          ]
          ||
          option.label;
      }
    );

    const filterLabels = {
      vendor:
        ui.filterVendor,
      formato:
        ui.filterFormat,
      alergenos:
        ui.filterAllergens,
      preferencias:
        ui.filterPreferences,
      sostenibilidad:
        ui.filterSustainability,
      etapaVital:
        ui.filterLifeStage
    };

    FILTER_DEFS.forEach(
      def => {

        def.label =
          filterLabels[
            def.key
          ]
          ||
          def.label;
      }
    );
  }


  const FIELD_CONFIG = {

    title: {
      phrase: 120,
      token: 100,
      fuzzy: true,
      prefix: true,
      label: 'Título'
    },

    searchTerms: {
      phrase: 90,
      token: 85,
      fuzzy: true,
      prefix: true,
      label: 'Términos de búsqueda'
    },

    type: {
      phrase: 70,
      token: 65,
      fuzzy: true,
      prefix: true,
      label: 'Tipo'
    },

    use: {
      phrase: 60,
      token: 50,
      fuzzy: true,
      prefix: true,
      label: 'Para qué sirve'
    },

    what: {
      phrase: 55,
      token: 45,
      fuzzy: true,
      prefix: true,
      label: 'Qué es'
    },

    vendor: {
      phrase: 25,
      token: 25,
      fuzzy: true,
      prefix: true,
      label: 'Marca'
    },

    ingredients: {
      phrase: 20,
      token: 20,
      fuzzy: true,
      prefix: false,
      label: 'Ingredientes'
    }

  };


  const FIELD_ORDER = [
    'title',
    'searchTerms',
    'type',
    'use',
    'what',
    'vendor',
    'ingredients'
  ];


  const STRICT_ALIAS_WEIGHTS = {
    title: 95,
    searchTerms: 90,
    type: 70,
    use: 55,
    what: 50,
    vendor: 25,
    ingredients: 20
  };


  const DIRECTIONAL_ALIAS_WEIGHTS = {
    title: 75,
    searchTerms: 70,
    type: 55,
    use: 45,
    what: 40,
    vendor: 20,
    ingredients: 18
  };


  const INTENT_WEIGHTS = {
    title: 55,
    searchTerms: 50,
    type: 35,
    use: 55,
    what: 35,
    vendor: 0,
    ingredients: 0
  };


  /* =========================================================
     UTILIDADES
     ========================================================= */

  function perfNow() {
    return (
      window.performance &&
      typeof performance.now === 'function'
    )
      ? performance.now()
      : Date.now();
  }


  function elapsedSince(start) {
    return Math.max(
      0,
      perfNow() - start
    );
  }


  function formatSeconds(ms) {
    return Number.isFinite(ms)
      ? `${(ms / 1000).toFixed(2)} s`
      : '—';
  }


  function formatCacheAge(ms) {

    if (!Number.isFinite(ms)) {
      return '';
    }

    const minutes =
      Math.floor(
        ms / 60000
      );

    if (minutes < 1) {
      return '<1 min';
    }

    if (minutes < 60) {
      return `${minutes} min`;
    }

    return `${Math.floor(minutes / 60)} h`;
  }


  function escapeHtml(value) {

    return String(
      value ??
      ''
    )
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  function debounce(
    fn,
    wait
  ) {

    let timer;

    return (...args) => {

      clearTimeout(timer);

      timer =
        setTimeout(
          () =>
            fn(...args),
          wait
        );
    };
  }


  function normalizeText(value) {

    return String(
      value ||
      ''
    )
      .normalize('NFD')
      .replace(
        /[\u0300-\u036f]/g,
        ''
      )
      .toLowerCase()
      .replace(
        /ß/g,
        'ss'
      )
      .replace(
        /[’'`´]/g,
        ' '
      )
      .replace(
        /[‐-‒–—−_-]+/g,
        ' '
      )
      .replace(
        /[^a-z0-9+µ\s]/g,
        ' '
      )
      .replace(
        /\s+/g,
        ' '
      )
      .trim();
  }


  function tokenizeNormalized(normalized) {

    return normalized
      ? normalized
          .split(' ')
          .filter(Boolean)
      : [];
  }


  function unique(values) {

    return [
      ...new Set(
        values.filter(Boolean)
      )
    ];
  }


  function containsWholePhrase(
    text,
    phrase
  ) {

    return Boolean(
      text &&
      phrase &&
      ` ${text} `.includes(
        ` ${phrase} `
      )
    );
  }


  function conservativePluralEquivalent(
    a,
    b
  ) {

    if (!a || !b) {
      return false;
    }

    if (a === b) {
      return true;
    }

    if (
      a.length < 3 ||
      b.length < 3
    ) {
      return false;
    }

    return (
      `${a}s` === b ||
      `${b}s` === a ||
      `${a}es` === b ||
      `${b}es` === a
    );
  }


  function containsConservativePluralVariant(
    text,
    queryToken
  ) {

    if (!text || !queryToken) {
      return false;
    }

    return tokenizeNormalized(text)
      .some(
        token =>
          conservativePluralEquivalent(
            token,
            queryToken
          )
      );
  }


  function startsWithToken(
    tokenSet,
    prefix
  ) {

    if (
      !prefix ||
      prefix.length < 3
    ) {
      return false;
    }

    for (const token of tokenSet) {

      if (
        token.startsWith(prefix)
      ) {
        return true;
      }
    }

    return false;
  }


  function allTokensPresent(
    tokenSet,
    phrase
  ) {

    const tokens =
      tokenizeNormalized(phrase);

    return Boolean(
      tokens.length &&
      tokens.every(
        token =>
          tokenSet.has(token)
      )
    );
  }


  function extractSearchableIngredients(value) {

    const text =
      String(
        value ||
        ''
      ).trim();

    if (!text) {
      return '';
    }

    const stopPattern =
      /(?:al[eé]rgenos\s+e\s+intolerancias|otras\s+caracter[ií]sticas|allergens?\s+(?:and|&)\s+intolerances?|other\s+(?:characteristics|features)|allergene?\s+und\s+unvertr[aä]glichkeiten|weitere\s+eigenschaften|andere\s+eigenschaften)\s*:/i;

    const match =
      stopPattern.exec(text);

    return match
      ? text
          .slice(
            0,
            match.index
          )
          .trim()
      : text;
  }


  function removeIngredientExclusionPhrases(
    value,
    exclusions
  ) {

    let text =
      normalizeText(value);

    if (
      !text ||
      !Array.isArray(exclusions) ||
      !exclusions.length
    ) {
      return text;
    }

    const phrases =
      exclusions
        .map(normalizeText)
        .filter(Boolean)
        .sort(
          (a, b) =>
            b.length - a.length
        );

    for (const phrase of phrases) {

      const paddedText =
        ` ${text} `;

      const paddedPhrase =
        ` ${phrase} `;

      if (
        paddedText.includes(
          paddedPhrase
        )
      ) {

        text =
          paddedText
            .split(
              paddedPhrase
            )
            .join(' ')
            .replace(
              /\s+/g,
              ' '
            )
            .trim();
      }
    }

    return text;
  }


  function parseListMetafield(value) {

    if (!value) {
      return [];
    }

    try {

      const parsed =
        JSON.parse(value);

      return Array.isArray(parsed)
        ? parsed
            .map(String)
            .filter(Boolean)
        : [
            String(parsed)
          ];

    } catch (_) {

      return String(value)
        .split(
          /\r?\n|\s*[,;|]\s*/
        )
        .map(
          item =>
            item.trim()
        )
        .filter(Boolean);
    }
  }


  function parseFilterMetafield(metafield) {

    if (!metafield?.value) {
      return [];
    }

    const type =
      String(
        metafield.type ||
        ''
      );

    if (
      type.startsWith('list.')
    ) {

      return cleanFilterValues(
        parseListMetafield(
          metafield.value
        )
      );
    }

    return cleanFilterValues([
      String(metafield.value)
    ]);
  }


  function cleanFilterValues(values) {

    const seen =
      new Set();

    const out =
      [];

    for (const raw of values || []) {

      const label =
        String(
          raw ||
          ''
        ).trim();

      const norm =
        normalizeText(label);

      if (
        !label ||
        !norm ||
        seen.has(norm)
      ) {
        continue;
      }

      seen.add(norm);

      out.push(label);
    }

    return out;
  }


  function numericIdFromGid(gid) {

    const match =
      String(
        gid ||
        ''
      )
        .match(
          /\/(\d+)$/
        );

    return match
      ? Number(match[1])
      : null;
  }


  function formatMoney(
    amount,
    currency,
    locale
  ) {

    const number =
      Number(amount);

    if (
      !Number.isFinite(number)
    ) {
      return '';
    }

    try {

      return new Intl.NumberFormat(
        locale ||
        'es-ES',
        {
          style: 'currency',
          currency:
            currency ||
            'EUR'
        }
      )
        .format(number);

    } catch (_) {

      return (
        `${number.toFixed(2)} ` +
        `${currency || 'EUR'}`
      );
    }
  }


  function formatActiveIngredient(value) {

    const escaped =
      escapeHtml(
        value ||
        ''
      );

    if (!escaped) {
      return '';
    }

    return escaped
      .replace(
        /10¹¹/g,
        '10<sup>11</sup>'
      )
      .replace(
        /10¹⁰/g,
        '10<sup>10</sup>'
      )
      .replace(
        /10⁹/g,
        '10<sup>9</sup>'
      )
      .replace(
        /10⁸/g,
        '10<sup>8</sup>'
      )
      .replace(
        /10⁷/g,
        '10<sup>7</sup>'
      )
      .replace(
        /10⁶/g,
        '10<sup>6</sup>'
      );
  }


  function formatRatingValue(value) {

    const number =
      Number(value);

    if (
      !Number.isFinite(number) ||
      number <= 0
    ) {
      return '';
    }

    const rounded =
      Math.round(
        number * 10
      ) / 10;

    return Number.isInteger(rounded)
      ? String(rounded)
      : rounded.toFixed(1);
  }


  function parseRatingMetafield(value) {

    if (!value) {
      return null;
    }

    try {

      const parsed =
        JSON.parse(value);

      const number =
        Number(
          parsed?.value ??
          parsed?.rating ??
          parsed
        );

      return Number.isFinite(number)
        ? number
        : null;

    } catch (_) {

      const number =
        Number(value);

      return Number.isFinite(number)
        ? number
        : null;
    }
  }


  function parseNumericMetafield(value) {

    if (
      value === null ||
      value === undefined ||
      value === ''
    ) {
      return null;
    }

    try {

      const parsed =
        JSON.parse(value);

      const number =
        Number(
          parsed?.value ??
          parsed
        );

      return Number.isFinite(number)
        ? number
        : null;

    } catch (_) {

      const number =
        Number(value);

      return Number.isFinite(number)
        ? number
        : null;
    }
  }


  function parseJudgeMeBadge(value) {

    const html =
      String(
        value ||
        ''
      );

    if (!html) {

      return {
        rating: null,
        count: null
      };
    }

    const ratingMatch =
      html.match(
        /data-average-rating=['"]([^'"]+)['"]/i
      );

    const countMatch =
      html.match(
        /data-number-of-reviews=['"]([^'"]+)['"]/i
      );

    const rating =
      ratingMatch
        ? Number(ratingMatch[1])
        : null;

    const count =
      countMatch
        ? Number(countMatch[1])
        : null;

    return {

      rating:
        Number.isFinite(rating)
          ? rating
          : null,

      count:
        Number.isFinite(count)
          ? count
          : null
    };
  }


  function longestContainedForm(
    query,
    forms
  ) {

    return (
      forms
        .filter(
          form =>
            form &&
            containsWholePhrase(
              query,
              form
            )
        )
        .sort(
          (a, b) =>
            b.length - a.length
        )[0]
      ||
      null
    );
  }


  /* =========================================================
     PARÉNTESIS
     ========================================================= */

  function queryOnlyInsideParentheses(
    title,
    normalizedQuery,
    stopwords =
      STOPWORDS_BY_LANGUAGE.es
  ) {

    if (
      !title ||
      !normalizedQuery
    ) {
      return false;
    }

    const rawTitle =
      String(title);

    const matches = [
      ...rawTitle.matchAll(
        /\(([^()]*)\)/g
      )
    ];

    if (!matches.length) {
      return false;
    }

    const inside =
      matches
        .map(
          match =>
            normalizeText(
              match[1]
            )
        )
        .filter(Boolean);

    const outside =
      normalizeText(
        rawTitle.replace(
          /\([^()]*\)/g,
          ' '
        )
      );

    const queryTokens =
      tokenizeNormalized(
        normalizedQuery
      )
        .filter(
          token =>
            !stopwords.has(token) &&
            token.length >= 2
        );

    if (!queryTokens.length) {
      return false;
    }

    const tokenInside =
      token =>
        inside.some(
          segment =>
            containsWholePhrase(
              segment,
              token
            )
            ||
            containsConservativePluralVariant(
              segment,
              token
            )
        );

    const tokenOutside =
      token =>
        containsWholePhrase(
          outside,
          token
        )
        ||
        containsConservativePluralVariant(
          outside,
          token
        );

    return (
      queryTokens.some(tokenInside) &&
      !queryTokens.some(tokenOutside)
    );
  }


  /* =========================================================
     FUZZY
     ========================================================= */

  function fuzzyThreshold(token) {

    if (
      !token ||
      token.length < 5
    ) {
      return 0;
    }

    return token.length <= 9
      ? 1
      : 2;
  }


  function levenshteinWithin(
    a,
    b,
    maxDistance
  ) {

    if (a === b) {
      return 0;
    }

    if (
      !a ||
      !b ||
      Math.abs(
        a.length -
        b.length
      ) > maxDistance
    ) {
      return null;
    }

    const previous =
      new Array(
        b.length + 1
      );

    const current =
      new Array(
        b.length + 1
      );

    for (
      let j = 0;
      j <= b.length;
      j++
    ) {
      previous[j] = j;
    }

    for (
      let i = 1;
      i <= a.length;
      i++
    ) {

      current[0] = i;

      let rowMinimum =
        current[0];

      for (
        let j = 1;
        j <= b.length;
        j++
      ) {

        const cost =
          a[i - 1] ===
          b[j - 1]
            ? 0
            : 1;

        current[j] =
          Math.min(
            previous[j] + 1,
            current[j - 1] + 1,
            previous[j - 1] + cost
          );

        rowMinimum =
          Math.min(
            rowMinimum,
            current[j]
          );
      }

      if (
        rowMinimum >
        maxDistance
      ) {
        return null;
      }

      for (
        let j = 0;
        j <= b.length;
        j++
      ) {
        previous[j] =
          current[j];
      }
    }

    return previous[b.length] <= maxDistance
      ? previous[b.length]
      : null;
  }


  /* =========================================================
     INDEXEDDB
     ========================================================= */

  function openIndexedDB() {

    if (IDB_PROMISE) {
      return IDB_PROMISE;
    }

    IDB_PROMISE =
      new Promise(
        (
          resolve,
          reject
        ) => {

          if (
            !(
              'indexedDB'
              in window
            )
          ) {

            reject(
              new Error(
                'IndexedDB no está disponible.'
              )
            );

            return;
          }

          const request =
            indexedDB.open(
              IDB_NAME,
              IDB_VERSION
            );

          request.onupgradeneeded =
            event => {

              const db =
                event.target.result;

              if (
                !db
                  .objectStoreNames
                  .contains(
                    IDB_STORE
                  )
              ) {

                db.createObjectStore(
                  IDB_STORE,
                  {
                    keyPath:
                      'key'
                  }
                );
              }
            };

          request.onsuccess =
            () =>
              resolve(
                request.result
              );

          request.onerror =
            () => {

              IDB_PROMISE =
                null;

              reject(
                request.error ||
                new Error(
                  'No se pudo abrir IndexedDB.'
                )
              );
            };

          request.onblocked =
            () =>
              console.warn(
                '[BT Search] IndexedDB bloqueado temporalmente.'
              );
        }
      );

    return IDB_PROMISE;
  }


  async function idbGet(key) {

    const db =
      await openIndexedDB();

    return new Promise(
      (
        resolve,
        reject
      ) => {

        const tx =
          db.transaction(
            IDB_STORE,
            'readonly'
          );

        const request =
          tx
            .objectStore(
              IDB_STORE
            )
            .get(key);

        request.onsuccess =
          () =>
            resolve(
              request.result ||
              null
            );

        request.onerror =
          () =>
            reject(
              request.error
            );
      }
    );
  }


  async function idbPut(record) {

    const db =
      await openIndexedDB();

    return new Promise(
      (
        resolve,
        reject
      ) => {

        const tx =
          db.transaction(
            IDB_STORE,
            'readwrite'
          );

        tx
          .objectStore(
            IDB_STORE
          )
          .put(record);

        tx.oncomplete =
          () =>
            resolve(true);

        tx.onerror =
          () =>
            reject(
              tx.error
            );

        tx.onabort =
          () =>
            reject(
              tx.error ||
              new Error(
                'La escritura IndexedDB fue cancelada.'
              )
            );
      }
    );
  }


  async function idbDelete(key) {

    const db =
      await openIndexedDB();

    return new Promise(
      (
        resolve,
        reject
      ) => {

        const tx =
          db.transaction(
            IDB_STORE,
            'readwrite'
          );

        tx
          .objectStore(
            IDB_STORE
          )
          .delete(key);

        tx.oncomplete =
          () =>
            resolve(true);

        tx.onerror =
          () =>
            reject(
              tx.error
            );
      }
    );
  }


  function cleanupLegacyLocalStorage() {

    try {

      const keys = [];

      for (
        let i = 0;
        i < localStorage.length;
        i++
      ) {

        const key =
          localStorage.key(i);

        if (
          key &&
          key.startsWith(
            'bt-search-v'
          )
        ) {
          keys.push(key);
        }
      }

      keys.forEach(
        key =>
          localStorage.removeItem(key)
      );

    } catch (_) {}
  }


  /* =========================================================
     CONTEXTO B2B
     ========================================================= */

  function normalizeCompanyLocationId(value) {

    const raw =
      String(
        value ||
        ''
      )
        .trim();

    if (!raw) {
      return '';
    }

    if (
      raw.startsWith(
        'gid://shopify/CompanyLocation/'
      )
    ) {
      return raw;
    }

    const numeric =
      raw.match(/(\d+)$/)?.[1];

    return numeric
      ? `gid://shopify/CompanyLocation/${numeric}`
      : raw;
  }


  function sectionJsonPayload(
    html,
    selector
  ) {

    const rawHtml =
      String(html || '');

    const documentNode =
      new DOMParser()
        .parseFromString(
          rawHtml,
          'text/html'
        );

    const node =
      documentNode
        .querySelector(
          selector
        );

    if (!node) {
      return null;
    }

    const rawPayload =
      (
        typeof node.value ===
          'string'
          ? node.value
          : node.textContent
      )
      ||
      '';

    try {
      return JSON.parse(
        rawPayload ||
        '{}'
      );
    } catch (error) {

      console.error(
        '[BT Search] JSON inválido en una sección Liquid.',
        {
          selector,
          error,
          payloadStart:
            rawPayload.slice(
              0,
              600
            ),
          payloadEnd:
            rawPayload.slice(
              -600
            )
        }
      );

      return null;
    }
  }


  async function resolveBuyerContext(config) {

    const fallback = {
      isB2B:
        Boolean(
          config.isB2B
        ),

      companyLocationId:
        normalizeCompanyLocationId(
          config.companyLocationId
        ),

      source:
        'config'
    };

    const rootUrlRaw =
      window.Shopify
        ?.routes
        ?.root
      ||
      config.rootUrl
      ||
      '/';

    const rootUrl =
      rootUrlRaw.endsWith('/')
        ? rootUrlRaw
        : `${rootUrlRaw}/`;

    const sectionId =
      config.b2bContextSectionId ||
      B2B_CONTEXT_SECTION_ID;

    const promiseKey =
      `${window.location.origin}:${rootUrl}:${sectionId}`;

    if (
      GLOBAL_BUYER_CONTEXT_PROMISES.has(
        promiseKey
      )
    ) {
      return GLOBAL_BUYER_CONTEXT_PROMISES.get(
        promiseKey
      );
    }

    const promise =
      (
        async () => {

          try {

            const url =
              new URL(
                rootUrl,
                window.location.origin
              );

            url.searchParams.set(
              'section_id',
              sectionId
            );

            const response =
              await fetch(
                url.toString(),
                {
                  credentials:
                    'same-origin',
                  cache:
                    'no-store',
                  headers: {
                    'X-Requested-With':
                      'XMLHttpRequest'
                  }
                }
              );

            if (!response.ok) {
              throw new Error(
                `HTTP ${response.status}`
              );
            }

            const html =
              await response.text();

            const payload =
              sectionJsonPayload(
                html,
                '[data-bt-search-buyer-context]'
              );

            if (!payload) {
              throw new Error(
                'Respuesta sin contexto B2B.'
              );
            }

            return {
              isB2B:
                Boolean(
                  payload.isB2B
                ),

              companyLocationId:
                normalizeCompanyLocationId(
                  payload.companyLocationId
                ),

              source:
                'liquid'
            };

          } catch (error) {

            console.warn(
              '[BT Search] No se pudo resolver el contexto B2B por Liquid; se usa el fallback del DOM.',
              error
            );

            return fallback;
          }
        }
      )();

    GLOBAL_BUYER_CONTEXT_PROMISES.set(
      promiseKey,
      promise
    );

    return promise;
  }


  /* =========================================================
     STOREFRONT LOADER
     ========================================================= */

  class StorefrontIndexLoader {

    constructor(config) {

      this.shopDomain =
        config.shopDomain;

      this.token =
        config.token;

      this.apiVersion =
        config.apiVersion ||
        DEFAULT_API_VERSION;

      this.dictionaryUrl =
        config.dictionaryUrl;

      this.locale =
        config.locale ||
        'es';

      this.languageCode =
        storefrontLanguageCode(
          this.locale
        );

      const configuredRootUrl =
        window.Shopify
          ?.routes
          ?.root
        ||
        config.rootUrl
        ||
        '/';

      this.rootUrl =
        configuredRootUrl.endsWith('/')
          ? configuredRootUrl
          : `${configuredRootUrl}/`;

      this.isB2B =
        Boolean(
          config.isB2B
        );

      this.companyLocationId =
        normalizeCompanyLocationId(
          config.companyLocationId
        );

      this.b2bIndexSectionId =
        config.b2bIndexSectionId ||
        B2B_INDEX_SECTION_ID;

      this.endpoint =
        `https://${this.shopDomain}/api/${this.apiVersion}/graphql.json`;

      const buyerCacheContext =
        this.isB2B
          ? `b2b:${this.companyLocationId || 'unknown-location'}`
          : 'b2c';

      this.cacheKey =
        `${CACHE_VERSION}:${this.shopDomain}:${this.languageCode}:${buyerCacheContext}`;
    }


    async readCache() {

      const started =
        perfNow();

      try {

        const record =
          await idbGet(
            this.cacheKey
          );

        const readMs =
          elapsedSince(
            started
          );

        if (!record) {

          return {
            cache: null,
            readMs
          };
        }

        if (
          !record.cachedAt ||
          !Array.isArray(
            record.products
          ) ||
          !Array.isArray(
            record.collections
          )
        ) {

          await idbDelete(
            this.cacheKey
          );

          return {
            cache: null,
            readMs
          };
        }

        const ageMs =
          Date.now() -
          record.cachedAt;

        const staleTtlMs =
          this.isB2B
            ? B2B_CACHE_STALE_TTL_MS
            : CACHE_STALE_TTL_MS;

        const freshTtlMs =
          this.isB2B
            ? B2B_CACHE_FRESH_TTL_MS
            : CACHE_FRESH_TTL_MS;

        if (
          ageMs >
          staleTtlMs
        ) {

          await idbDelete(
            this.cacheKey
          );

          return {
            cache: null,
            readMs
          };
        }

        return {

          cache: {
            data: record,
            ageMs,
            isFresh:
              ageMs <=
              freshTtlMs
          },

          readMs
        };

      } catch (error) {

        console.warn(
          '[BT Search] Error leyendo IndexedDB.',
          error
        );

        return {

          cache: null,

          readMs:
            elapsedSince(started),

          error
        };
      }
    }


    async writeCache(payload) {

      const started =
        perfNow();

      try {

        await idbPut({
          key: this.cacheKey,
          ...payload
        });

        return {
          ok: true,
          writeMs:
            elapsedSince(started)
        };

      } catch (error) {

        console.warn(
          '[BT Search] No se pudo guardar el índice en IndexedDB.',
          error
        );

        return {
          ok: false,
          writeMs:
            elapsedSince(started),
          error
        };
      }
    }


    async clearCache() {

      try {
        await idbDelete(
          this.cacheKey
        );
      } catch (_) {}
    }


    loadDictionary() {

      if (
        GLOBAL_DICTIONARY_PROMISES.has(
          this.dictionaryUrl
        )
      ) {

        return GLOBAL_DICTIONARY_PROMISES.get(
          this.dictionaryUrl
        );
      }

      const promise =
        fetch(
          this.dictionaryUrl,
          {
            credentials:
              'same-origin',
            cache:
              'force-cache'
          }
        )
          .then(
            response => {

              if (!response.ok) {

                throw new Error(
                  `No se pudo cargar el diccionario (${response.status}).`
                );
              }

              return response.json();
            }
          )
          .catch(
            error => {

              GLOBAL_DICTIONARY_PROMISES.delete(
                this.dictionaryUrl
              );

              throw error;
            }
          );

      GLOBAL_DICTIONARY_PROMISES.set(
        this.dictionaryUrl,
        promise
      );

      return promise;
    }


    async graphql(
      query,
      variables = {}
    ) {

      const response =
        await fetch(
          this.endpoint,
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              'X-Shopify-Storefront-Access-Token':
                this.token
            },

            body:
              JSON.stringify({
                query,
                variables
              })
          }
        );

      const json =
        await response
          .json()
          .catch(
            () => null
          );

      if (!response.ok) {

        throw new Error(
          json?.errors
            ?.map(
              error =>
                error.message
            )
            .join(' · ')
          ||
          `Storefront API: HTTP ${response.status}`
        );
      }

      if (json?.errors?.length) {

        throw new Error(
          json.errors
            .map(
              error =>
                error.message
            )
            .join(' · ')
        );
      }

      return json.data;
    }


    async load({
      force = false,
      revalidate = true
    } = {}) {

      const loadStarted =
        perfNow();

      if (!force) {

        const {
          cache,
          readMs
        } =
          await this.readCache();

        if (cache) {

          const dictionaryStarted =
            perfNow();

          const dictionary =
            await this.loadDictionary();

          const dictionaryMs =
            elapsedSince(
              dictionaryStarted
            );

          const result = {

            products:
              cache.data.products,

            collections:
              cache.data.collections,

            cachedAt:
              cache.data.cachedAt,

            dictionary,

            lastNetworkTimings:
              cache.data
                .lastNetworkTimings ||
              null,

            fromCache: true,

            cacheState:
              cache.isFresh
                ? 'fresh'
                : 'stale',

            cacheAgeMs:
              cache.ageMs,

            cachePersisted:
              true,

            cacheBackend:
              'IndexedDB',

            timings: {
              indexedDbReadMs:
                readMs,

              dictionaryMs,

              loadMs:
                elapsedSince(
                  loadStarted
                )
            }
          };

          if (
            !cache.isFresh &&
            revalidate
          ) {
            this.refreshInBackground();
          }

          return result;
        }
      }

      const fresh =
        await this.fetchFreshShared();

      return {
        ...fresh,

        timings: {
          ...fresh.timings,

          loadMs:
            elapsedSince(
              loadStarted
            )
        }
      };
    }


    fetchFreshShared() {

      if (
        GLOBAL_INFLIGHT.has(
          this.cacheKey
        )
      ) {

        return GLOBAL_INFLIGHT.get(
          this.cacheKey
        );
      }

      const promise =
        this
          .fetchFresh()
          .finally(
            () =>
              GLOBAL_INFLIGHT.delete(
                this.cacheKey
              )
          );

      GLOBAL_INFLIGHT.set(
        this.cacheKey,
        promise
      );

      return promise;
    }


    async fetchFresh() {

      const totalStarted =
        perfNow();

      let dictionaryMs = 0;
      let productsMs = 0;
      let collectionsMs = 0;

      if (this.isB2B) {
        return this.fetchFreshB2B(
          totalStarted
        );
      }

      const dictionaryPromise =
        (
          async () => {

            const started =
              perfNow();

            const result =
              await this.loadDictionary();

            dictionaryMs =
              elapsedSince(started);

            return result;
          }
        )();

      const productsPromise =
        (
          async () => {

            const started =
              perfNow();

            const result =
              await this.loadProducts();

            productsMs =
              elapsedSince(started);

            return result;
          }
        )();

      const collectionsPromise =
        (
          async () => {

            const started =
              perfNow();

            const result =
              await this.loadCollections();

            collectionsMs =
              elapsedSince(started);

            return result;
          }
        )();

      const [
        dictionary,
        products,
        collectionsWithMemberships
      ] =
        await Promise.all([
          dictionaryPromise,
          productsPromise,
          collectionsPromise
        ]);

      const attachStarted =
        perfNow();

      const productsWithCollections =
        this.attachCollectionsToProducts(
          products,
          collectionsWithMemberships
        );

      const attachMs =
        elapsedSince(
          attachStarted
        );

      const publicCollections =
        collectionsWithMemberships
          .map(
            collection => ({
              id:
                collection.id,

              handle:
                collection.handle,

              title:
                collection.title,

              onlineStoreUrl:
                collection.onlineStoreUrl,

              searchTerms:
                collection.searchTerms ||
                []
            })
          );

      const lastNetworkTimings = {
        dictionaryMs,
        productsMs,
        collectionsMs,
        attachMs,
        totalMs:
          elapsedSince(
            totalStarted
          )
      };

      const payload = {

        products:
          productsWithCollections,

        collections:
          publicCollections,

        cachedAt:
          Date.now(),

        lastNetworkTimings
      };

      const cacheResult =
        await this.writeCache(
          payload
        );

      return {
        ...payload,

        dictionary,

        fromCache: false,
        cacheState: 'network',
        cacheAgeMs: 0,

        cachePersisted:
          cacheResult.ok,

        cacheBackend:
          'IndexedDB',

        timings: {
          dictionaryMs,
          productsMs,
          collectionsMs,
          attachMs,

          indexedDbWriteMs:
            cacheResult.writeMs,

          loadMs:
            elapsedSince(
              totalStarted
            )
        }
      };
    }


    normalizeLiquidMetafields(rawMetafields) {

      return (
        rawMetafields ||
        []
      )
        .filter(
          metafield =>
            metafield &&
            metafield.key
        )
        .map(
          metafield => {

            const rawValue =
              metafield.value;

            let value = '';

            if (
              rawValue !== null &&
              rawValue !== undefined
            ) {

              if (
                typeof rawValue ===
                  'object'
              ) {
                try {
                  value =
                    JSON.stringify(
                      rawValue
                    );
                } catch (_) {
                  value =
                    String(rawValue);
                }
              } else {
                value =
                  String(rawValue);
              }
            }

            return {
              namespace:
                metafield.namespace ||
                '',
              key:
                metafield.key,
              type:
                metafield.type ||
                '',
              value
            };
          }
        );
    }


    normalizeB2BLiquidProduct(
      rawProduct,
      bestSellingRank
    ) {

      const normalized = {
        ...rawProduct,
        metafields:
          this.normalizeLiquidMetafields(
            rawProduct.metafields
          )
      };

      const product =
        this.mapProduct(
          normalized,
          bestSellingRank
        );

      if (!product) {
        return null;
      }

      product.collections =
        (
          rawProduct.btCollections ||
          []
        )
          .filter(
            collection =>
              collection &&
              collection.handle
          )
          .map(
            collection => ({
              handle:
                collection.handle,
              title:
                collection.title ||
                collection.handle
            })
          );

      return product;
    }


    async fetchB2BIndexPage(pageNumber) {

      const baseUrl =
        new URL(
          `${this.rootUrl}collections/all`,
          window.location.origin
        );

      baseUrl.searchParams.set(
        'sort_by',
        'best-selling'
      );

      baseUrl.searchParams.set(
        'page',
        String(pageNumber)
      );

      baseUrl.searchParams.set(
        'section_id',
        this.b2bIndexSectionId
      );

      const response =
        await fetch(
          baseUrl.toString(),
          {
            credentials:
              'same-origin',
            cache:
              'no-store',
            headers: {
              'X-Requested-With':
                'XMLHttpRequest'
            }
          }
        );

      if (!response.ok) {
        throw new Error(
          `Índice B2B Liquid: HTTP ${response.status}`
        );
      }

      const html =
        await response.text();

      const payload =
        sectionJsonPayload(
          html,
          '[data-bt-b2b-index]'
        );

      if (!payload) {
        throw new Error(
          'La sección bt-search-b2b-index no devolvió JSON válido. Revisa la consola para ver el fragmento que falló.'
        );
      }

      if (!payload.isB2B) {
        throw new Error(
          'Shopify no está renderizando la solicitud como cliente B2B.'
        );
      }

      const returnedLocationId =
        normalizeCompanyLocationId(
          payload.companyLocationId
        );

      if (
        this.companyLocationId &&
        returnedLocationId &&
        returnedLocationId !==
          this.companyLocationId
      ) {
        throw new Error(
          'La sucursal B2B cambió durante la construcción del índice.'
        );
      }

      return {
        ...payload,
        companyLocationId:
          returnedLocationId
      };
    }


    async loadB2BIndex() {

      const firstPage =
        await this.fetchB2BIndexPage(1);

      const totalPages =
        Math.max(
          1,
          Number(
            firstPage.pages ||
            1
          )
        );

      if (totalPages > 500) {
        throw new Error(
          'El índice B2B supera el límite de paginación de seguridad.'
        );
      }

      const pagePayloads =
        new Array(totalPages);

      pagePayloads[0] =
        firstPage;

      let nextPage = 2;

      const worker =
        async () => {

          while (
            nextPage <=
            totalPages
          ) {

            const page =
              nextPage;

            nextPage += 1;

            pagePayloads[
              page - 1
            ] =
              await this.fetchB2BIndexPage(
                page
              );
          }
        };

      const workerCount =
        Math.min(
          B2B_INDEX_CONCURRENCY,
          Math.max(
            0,
            totalPages - 1
          )
        );

      await Promise.all(
        Array.from(
          {
            length:
              workerCount
          },
          () => worker()
        )
      );

      const products = [];
      const collectionsMap =
        new Map();

      let rank = 0;

      for (
        const pagePayload
        of pagePayloads
      ) {

        for (
          const rawProduct
          of pagePayload?.products ||
          []
        ) {

          rank += 1;

          const product =
            this.normalizeB2BLiquidProduct(
              rawProduct,
              rank
            );

          if (product) {
            products.push(product);
          }

          for (
            const rawCollection
            of rawProduct
              ?.btCollections ||
            []
          ) {

            if (
              !rawCollection ||
              !rawCollection.handle
            ) {
              continue;
            }

            const collectionId =
              rawCollection.id ||
              rawCollection.handle;

            if (
              !collectionsMap.has(
                collectionId
              )
            ) {

              collectionsMap.set(
                collectionId,
                {
                  id:
                    rawCollection.id ||
                    collectionId,
                  handle:
                    rawCollection.handle,
                  title:
                    rawCollection.title ||
                    rawCollection.handle,
                  onlineStoreUrl:
                    rawCollection.onlineStoreUrl ||
                    `${this.rootUrl}collections/${rawCollection.handle}`,
                  searchTerms:
                    Array.isArray(
                      rawCollection.searchTerms
                    )
                      ? rawCollection.searchTerms
                      : parseListMetafield(
                          rawCollection.searchTerms
                        )
                }
              );
            }
          }
        }
      }

      return {
        products,
        collections:
          Array.from(
            collectionsMap.values()
          )
      };
    }


    async fetchFreshB2B(totalStarted) {

      let dictionaryMs = 0;
      let productsMs = 0;

      const dictionaryPromise =
        (
          async () => {

            const started =
              perfNow();

            const result =
              await this.loadDictionary();

            dictionaryMs =
              elapsedSince(started);

            return result;
          }
        )();

      const indexPromise =
        (
          async () => {

            const started =
              perfNow();

            const result =
              await this.loadB2BIndex();

            productsMs =
              elapsedSince(started);

            return result;
          }
        )();

      const [
        dictionary,
        index
      ] =
        await Promise.all([
          dictionaryPromise,
          indexPromise
        ]);

      const lastNetworkTimings = {
        source:
          'liquid-b2b',
        dictionaryMs,
        productsMs,
        collectionsMs: 0,
        attachMs: 0,
        totalMs:
          elapsedSince(
            totalStarted
          )
      };

      const payload = {
        products:
          index.products,
        collections:
          index.collections,
        cachedAt:
          Date.now(),
        lastNetworkTimings
      };

      const cacheResult =
        await this.writeCache(
          payload
        );

      return {
        ...payload,
        dictionary,
        fromCache: false,
        cacheState: 'network',
        cacheAgeMs: 0,
        cachePersisted:
          cacheResult.ok,
        cacheBackend:
          'IndexedDB',
        timings: {
          dictionaryMs,
          productsMs,
          collectionsMs: 0,
          attachMs: 0,
          indexedDbWriteMs:
            cacheResult.writeMs,
          loadMs:
            elapsedSince(
              totalStarted
            )
        }
      };
    }


    refreshInBackground() {

      if (
        GLOBAL_BACKGROUND_REFRESHES.has(
          this.cacheKey
        )
      ) {
        return;
      }

      const refreshPromise =
        this
          .fetchFreshShared()
          .then(
            result => {

              window.dispatchEvent(
                new CustomEvent(
                  'bt-search:index-updated',
                  {
                    detail: {
                      cacheKey:
                        this.cacheKey,
                      result
                    }
                  }
                )
              );

              return result;
            }
          )
          .catch(
            error =>
              console.warn(
                '[BT Search] Falló la actualización silenciosa.',
                error
              )
          )
          .finally(
            () =>
              GLOBAL_BACKGROUND_REFRESHES.delete(
                this.cacheKey
              )
          );

      GLOBAL_BACKGROUND_REFRESHES.set(
        this.cacheKey,
        refreshPromise
      );
    }


    /* =======================================================
       PRODUCTOS
       ======================================================= */

    async loadProducts() {

      const query = `

        query BTSearchProducts(
          $first: Int!,
          $after: String,
          $language: LanguageCode!
        )
        @inContext(
          language: $language
        ) {

          products(
            first: $first,
            after: $after,
            sortKey: BEST_SELLING
          ) {

            nodes {

              id
              handle
              title
              vendor
              productType
              availableForSale

              featuredImage {
                url
                altText
              }

              images(first: 3) {
                nodes {
                  url
                  altText
                }
              }

              priceRange {

                minVariantPrice {
                  amount
                  currencyCode
                }

              }

              selectedOrFirstAvailableVariant {

                id
                availableForSale

                price {
                  amount
                  currencyCode
                }

                compareAtPrice {
                  amount
                  currencyCode
                }

                unitPrice {
                  amount
                  currencyCode
                }

                unitPriceMeasurement {
                  measuredType
                  quantityUnit
                  quantityValue
                  referenceUnit
                  referenceValue
                }

              }

              metafields(
                identifiers: [

                  {
                    namespace: "custom",
                    key: "que_es"
                  },

                  {
                    namespace: "custom",
                    key: "para_que_sirve"
                  },

                  {
                    namespace: "custom",
                    key: "terminos_de_busqueda"
                  },

                  {
                    namespace: "custom",
                    key: "ingredientes"
                  },

                  {
                    namespace: "custom",
                    key: "principio_activo"
                  },

                  {
                    namespace: "custom",
                    key: "formato"
                  },

                  {
                    namespace: "custom",
                    key: "filtros_alergenos"
                  },

                  {
                    namespace: "custom",
                    key: "filtros_dietas_y_preferencias_alimentarias"
                  },

                  {
                    namespace: "custom",
                    key: "filtros_sostenibilidad_y_origen"
                  },

                  {
                    namespace: "custom",
                    key: "filtros_etapa_vital"
                  },

                  {
                    namespace: "reviews",
                    key: "rating"
                  },

                  {
                    namespace: "reviews",
                    key: "rating_count"
                  },

                  {
                    namespace: "judgeme",
                    key: "badge"
                  }

                ]
              ) {

                namespace
                key
                type
                value

              }

            }

            pageInfo {
              hasNextPage
              endCursor
            }

          }

        }

      `;

      const products = [];

      let after = null;
      let guard = 0;

      do {

        const data =
          await this.graphql(
            query,
            {
              first: 250,
              after,
              language:
                this.languageCode
            }
          );

        const connection =
          data.products;

        products.push(
          ...connection.nodes
        );

        after =
          connection
            .pageInfo
            .hasNextPage
              ? connection
                  .pageInfo
                  .endCursor
              : null;

        guard += 1;

        if (guard > 20) {

          throw new Error(
            'Se detuvo la paginación de productos por seguridad.'
          );
        }

      } while (after);

      return products
        .map(
          (
            product,
            index
          ) =>
            this.mapProduct(
              product,
              index + 1
            )
        )
        .filter(Boolean);
    }


    mapProduct(
      product,
      bestSellingRank
    ) {

      const normalizedTitle =
        normalizeText(
          product.title
        );

      if (
        containsWholePhrase(
          normalizedTitle,
          'descatalogado'
        )
        ||
        containsWholePhrase(
          normalizedTitle,
          'discontinued'
        )
        ||
        containsWholePhrase(
          normalizedTitle,
          'eingestellt'
        )
        ||
        containsWholePhrase(
          normalizedTitle,
          'aus dem sortiment'
        )
        ||
        containsWholePhrase(
          normalizedTitle,
          'old'
        )
        ||
        /(?:^|-)old(?:-|$)/i.test(
          product.handle
        )
      ) {
        return null;
      }

      const metafields = {};

      for (
        const metafield
        of product.metafields ||
        []
      ) {

        if (metafield?.key) {

          metafields[
            `${metafield.namespace}.${metafield.key}`
          ] =
            metafield;
        }
      }

      const searchTerms =
        parseListMetafield(
          metafields[
            'custom.terminos_de_busqueda'
          ]?.value
        );

      const ingredients =
        extractSearchableIngredients(
          metafields[
            'custom.ingredientes'
          ]?.value ||
          ''
        );

      const activeIngredient =
        metafields[
          'custom.principio_activo'
        ]?.value ||
        '';

      const judgeMe =
        parseJudgeMeBadge(
          metafields[
            'judgeme.badge'
          ]?.value
        );

      const ratingValue =
        parseRatingMetafield(
          metafields[
            'reviews.rating'
          ]?.value
        )
        ??
        judgeMe.rating;

      const ratingCount =
        parseNumericMetafield(
          metafields[
            'reviews.rating_count'
          ]?.value
        )
        ??
        judgeMe.count
        ??
        0;

      const secondaryImage =
        (
          product
            .images
            ?.nodes ||
          []
        )
          .find(
            image =>
              image?.url &&
              image.url !==
              product
                .featuredImage
                ?.url
          )
        ||
        null;

      const rawVariant =
        product
          .selectedOrFirstAvailableVariant;

      const preferredVariant =
        rawVariant
          ? {

              id:
                rawVariant.id,

              numericId:
                numericIdFromGid(
                  rawVariant.id
                ),

              availableForSale:
                Boolean(
                  rawVariant.availableForSale
                ),

              price:
                rawVariant.price,

              compareAtPrice:
                rawVariant.compareAtPrice,

              unitPrice:
                rawVariant.unitPrice ||
                null,

              unitPriceMeasurement:
                rawVariant.unitPriceMeasurement ||
                null
            }
          : null;

      return {

        id:
          product.id,

        handle:
          product.handle,

        title:
          product.title,

        bestSellingRank:
          Number.isFinite(
            bestSellingRank
          )
            ? bestSellingRank
            : 999999,

        vendor:
          product.vendor ||
          '',

        type:
          product.productType ||
          '',

        available:
          Boolean(
            product.availableForSale
          ),

        image:
          product.featuredImage ||
          null,

        secondaryImage,

        activeIngredient,

        ratingValue:
          Number.isFinite(
            ratingValue
          )
            &&
            ratingValue > 0
            ? ratingValue
            : null,

        ratingCount:
          Number.isFinite(
            ratingCount
          )
            &&
            ratingCount > 0
            ? ratingCount
            : 0,

        minPrice:
          product
            .priceRange
            ?.minVariantPrice
          ||
          preferredVariant
            ?.price
          ||
          null,

        variant:
          preferredVariant,

        what:
          metafields[
            'custom.que_es'
          ]?.value ||
          '',

        use:
          metafields[
            'custom.para_que_sirve'
          ]?.value ||
          '',

        searchTerms,

        ingredients,

        filterValues: {

          vendor:
            cleanFilterValues([
              product.vendor
            ]),

          formato:
            parseFilterMetafield(
              metafields[
                'custom.formato'
              ]
            ),

          alergenos:
            parseFilterMetafield(
              metafields[
                'custom.filtros_alergenos'
              ]
            ),

          preferencias:
            parseFilterMetafield(
              metafields[
                'custom.filtros_dietas_y_preferencias_alimentarias'
              ]
            ),

          sostenibilidad:
            parseFilterMetafield(
              metafields[
                'custom.filtros_sostenibilidad_y_origen'
              ]
            ),

          etapaVital:
            parseFilterMetafield(
              metafields[
                'custom.filtros_etapa_vital'
              ]
            )
        },

        collections: []
      };
    }


    /* =======================================================
       COLECCIONES
       ======================================================= */

    async loadCollections() {

      const query = `

        query BTSearchCollections(
          $first: Int!,
          $after: String,
          $language: LanguageCode!
        )
        @inContext(
          language: $language
        ) {

          collections(
            first: $first,
            after: $after,
            sortKey: TITLE
          ) {

            nodes {

              id
              handle
              title
              onlineStoreUrl

              searchTermsMetafield: metafield(
                namespace: "custom",
                key: "terminos_de_busqueda"
              ) {
                type
                value
              }

              products(first: 250) {

                nodes {
                  id
                }

                pageInfo {
                  hasNextPage
                  endCursor
                }

              }

            }

            pageInfo {
              hasNextPage
              endCursor
            }

          }

        }

      `;

      const rawCollections = [];

      let after = null;
      let guard = 0;

      do {

        const data =
          await this.graphql(
            query,
            {
              first: 50,
              after,
              language:
                this.languageCode
            }
          );

        const connection =
          data.collections;

        rawCollections.push(
          ...connection.nodes
        );

        after =
          connection
            .pageInfo
            .hasNextPage
              ? connection
                  .pageInfo
                  .endCursor
              : null;

        guard += 1;

        if (guard > 20) {

          throw new Error(
            'Se detuvo la paginación de colecciones por seguridad.'
          );
        }

      } while (after);

      const collections =
        rawCollections
          .filter(
            collection =>
              Boolean(
                collection.onlineStoreUrl
              )
          )
          .map(
            collection => ({

              id:
                collection.id,

              handle:
                collection.handle,

              title:
                collection.title,

              onlineStoreUrl:
                collection.onlineStoreUrl,

              searchTerms:
                parseListMetafield(
                  collection
                    .searchTermsMetafield
                    ?.value
                ),

              productIds:
                (
                  collection
                    .products
                    ?.nodes ||
                  []
                )
                  .map(
                    product =>
                      product.id
                  ),

              productPageInfo:
                collection
                  .products
                  ?.pageInfo ||
                {
                  hasNextPage:
                    false,

                  endCursor:
                    null
                }
            })
          );

      for (
        const collection
        of collections
      ) {

        if (
          !collection
            .productPageInfo
            .hasNextPage
        ) {
          continue;
        }

        const remainingIds =
          await this
            .loadRemainingCollectionProductIds(
              collection.id,
              collection
                .productPageInfo
                .endCursor
            );

        collection
          .productIds
          .push(
            ...remainingIds
          );
      }

      return collections
        .map(
          collection => ({

            id:
              collection.id,

            handle:
              collection.handle,

            title:
              collection.title,

            onlineStoreUrl:
              collection.onlineStoreUrl,

            searchTerms:
              collection.searchTerms ||
              [],

            productIds:
              unique(
                collection.productIds
              )
          })
        );
    }


    async loadRemainingCollectionProductIds(
      collectionId,
      initialAfter
    ) {

      const query = `

        query BTSearchCollectionProducts(
          $id: ID!,
          $first: Int!,
          $after: String,
          $language: LanguageCode!
        )
        @inContext(
          language: $language
        ) {

          collection(id: $id) {

            products(
              first: $first,
              after: $after
            ) {

              nodes {
                id
              }

              pageInfo {
                hasNextPage
                endCursor
              }

            }

          }

        }

      `;

      const productIds = [];

      let after =
        initialAfter;

      let guard = 0;

      while (after) {

        const data =
          await this.graphql(
            query,
            {
              id:
                collectionId,

              first:
                250,

              after,

              language:
                this.languageCode
            }
          );

        const connection =
          data
            .collection
            ?.products;

        if (!connection) {
          break;
        }

        productIds.push(
          ...connection
            .nodes
            .map(
              product =>
                product.id
            )
        );

        after =
          connection
            .pageInfo
            .hasNextPage
              ? connection
                  .pageInfo
                  .endCursor
              : null;

        guard += 1;

        if (guard > 20) {

          throw new Error(
            'Se detuvo la paginación de productos de una colección por seguridad.'
          );
        }
      }

      return productIds;
    }


    attachCollectionsToProducts(
      products,
      collections
    ) {

      const memberships =
        new Map();

      for (
        const collection
        of collections
      ) {

        const collectionInfo = {
          handle:
            collection.handle,
          title:
            collection.title
        };

        for (
          const productId
          of collection.productIds ||
          []
        ) {

          if (
            !memberships.has(
              productId
            )
          ) {

            memberships.set(
              productId,
              []
            );
          }

          memberships
            .get(productId)
            .push(
              collectionInfo
            );
        }
      }

      return products
        .map(
          product => ({

            ...product,

            collections:
              memberships.get(
                product.id
              )
              ||
              []
          })
        );
    }
  }


  /* =========================================================
     MOTOR
     ========================================================= */

  class BTSearchEngine {

    constructor(
      products,
      collections,
      dictionary,
      locale = 'es'
    ) {

      this.locale =
        locale ||
        'es';

      this.languageKey =
        localeLanguageKey(
          this.locale
        );

      this.stopwords =
        stopwordsForLocale(
          this.locale
        );

      this.collatorLocale =
        collatorLocale(
          this.locale
        );

      this.dictionary =
        dictionary ||
        {};

      const localizedDictionary =
        localeDictionaryGroups(
          this.dictionary,
          this.locale
        );

      this.ingredientExclusions =
        Object.values(
          this.dictionary
            .matching_rules
            ?.ingredient_context_exclusions
          ||
          {}
        )
          .flat()
          .filter(Boolean);

      this.lowValueTokens =
        new Set(
          [
            ...(
              this.dictionary
                .matching_rules
                ?.dosage_tokens_low_value
              ||
              []
            ),

            ...(
              this.dictionary
                .matching_rules
                ?.marketing_tokens_low_value
              ||
              []
            )
          ]
            .map(normalizeText)
        );

      this.synonymGroups =
        localizedDictionary
          .synonymGroups
          .map(
            group => ({

              ...group,

              canonicalNorm:
                normalizeText(
                  group.canonical
                ),

              aliasNorms:
                (
                  group.aliases ||
                  []
                )
                  .map(normalizeText)
                  .filter(Boolean),

              queryAliasNorms:
                (
                  group.query_aliases ||
                  []
                )
                  .map(normalizeText)
                  .filter(Boolean)
            })
          );

      this.intentGroups =
        localizedDictionary
          .intentGroups
          .map(
            group => ({

              ...group,

              canonicalNorm:
                normalizeText(
                  group.canonical
                ),

              termNorms:
                (
                  group.terms ||
                  []
                )
                  .map(normalizeText)
                  .filter(Boolean)
            })
          );

      this.products =
        products
          .map(
            product =>
              this.prepareProduct(
                product
              )
          );

      this.collections =
        collections
          .map(
            collection =>
              this.prepareCollection(
                collection
              )
          );
    }


    prepareProduct(product) {

      const cleanedIngredients =
        removeIngredientExclusionPhrases(
          product.ingredients,
          this.ingredientExclusions
        );

      const sourceSegments = {

        title: [
          product.title
        ],

        searchTerms:
          product.searchTerms ||
          [],

        type: [
          product.type
        ],

        use: [
          product.use
        ],

        what: [
          product.what
        ],

        vendor: [
          product.vendor
        ],

        ingredients: [
          cleanedIngredients
        ]
      };

      const prepared = {};

      for (
        const fieldName
        of FIELD_ORDER
      ) {

        const normalizedSegments =
          sourceSegments[fieldName]
            .map(normalizeText)
            .filter(Boolean);

        const tokenSet =
          new Set();

        for (
          const segment
          of normalizedSegments
        ) {

          for (
            const token
            of tokenizeNormalized(
              segment
            )
          ) {
            tokenSet.add(token);
          }
        }

        prepared[fieldName] = {

          segments:
            normalizedSegments,

          text:
            normalizedSegments.join(
              ' '
            ),

          tokens:
            tokenSet
        };
      }

      const preparedCollections =
        (
          product.collections ||
          []
        )
          .map(
            collection => {

              const normalizedTitle =
                normalizeText(
                  collection.title
                );

              return {
                handle:
                  collection.handle,

                title:
                  collection.title,

                normalizedTitle,

                tokens:
                  new Set(
                    tokenizeNormalized(
                      normalizedTitle
                    )
                  )
              };
            }
          )
          .filter(
            collection =>
              collection.normalizedTitle
          );

      const filterSets = {};

      for (
        const def
        of FILTER_DEFS
      ) {

        filterSets[def.key] =
          new Set(
            (
              product
                .filterValues
                ?.[def.key]
              ||
              []
            )
              .map(normalizeText)
              .filter(Boolean)
          );
      }

      return {
        ...product,

        _prepared:
          prepared,

        _preparedCollections:
          preparedCollections,

        _filterSets:
          filterSets
      };
    }


    prepareCollection(collection) {

      const normalizedTitle =
        normalizeText(
          collection.title
        );

      const normalizedSearchTerms =
        (
          collection.searchTerms ||
          []
        )
          .map(normalizeText)
          .filter(Boolean);

      const searchTermTokens =
        new Set();

      for (
        const segment
        of normalizedSearchTerms
      ) {

        for (
          const token
          of tokenizeNormalized(
            segment
          )
        ) {
          searchTermTokens.add(token);
        }
      }

      return {
        ...collection,

        _prepared: {
          title:
            normalizedTitle,

          tokens:
            new Set(
              tokenizeNormalized(
                normalizedTitle
              )
            ),

          searchTerms:
            normalizedSearchTerms,

          searchTermTokens
        }
      };
    }


    buildQueryPlan(rawQuery) {

      const normalized =
        normalizeText(rawQuery);

      const rawTokens =
        tokenizeNormalized(
          normalized
        );

      let tokens =
        rawTokens
          .filter(
            token =>
              !this.stopwords.has(token)
          );

      const informativeTokens =
        tokens
          .filter(
            token =>
              !this
                .lowValueTokens
                .has(token)
          );

      if (
        informativeTokens.length
      ) {
        tokens =
          informativeTokens;
      }

      tokens =
        unique(tokens);

      const tokenConcepts =
        new Map();

      for (const token of tokens) {

        tokenConcepts.set(
          token,
          {
            queryForm: token,
            queryTokens: [
              token
            ],
            strictForms: [],
            directionalForms: [],
            intentForms: [],
            label: token
          }
        );
      }

      const phraseConcepts =
        new Map();

      const consumedTokens =
        new Set();

      const addExpansion = ({
        trigger,
        forms,
        kind,
        canonical
      }) => {

        if (!trigger) {
          return;
        }

        const triggerTokens =
          tokenizeNormalized(
            trigger
          )
            .filter(
              token =>
                !this.stopwords.has(token)
            );

        if (
          triggerTokens.length <= 1
        ) {

          const key =
            triggerTokens[0] ||
            trigger;

          if (
            !tokenConcepts.has(key)
          ) {

            tokenConcepts.set(
              key,
              {
                queryForm:
                  trigger,

                queryTokens:
                  triggerTokens,

                strictForms: [],
                directionalForms: [],
                intentForms: [],

                label:
                  canonical ||
                  trigger
              }
            );
          }

          const concept =
            tokenConcepts.get(key);

          concept[kind] =
            unique([
              ...concept[kind],

              ...forms.filter(
                form =>
                  form !== trigger
              )
            ]);

          return;
        }

        if (
          !phraseConcepts.has(
            trigger
          )
        ) {

          phraseConcepts.set(
            trigger,
            {
              queryForm:
                trigger,

              queryTokens:
                triggerTokens,

              strictForms: [],
              directionalForms: [],
              intentForms: [],

              label:
                canonical ||
                trigger
            }
          );
        }

        const concept =
          phraseConcepts.get(
            trigger
          );

        concept[kind] =
          unique([
            ...concept[kind],

            ...forms.filter(
              form =>
                form !== trigger
            )
          ]);

        triggerTokens.forEach(
          token =>
            consumedTokens.add(token)
        );
      };


      for (
        const group
        of this.synonymGroups
      ) {

        const strictForms =
          unique([
            group.canonicalNorm,
            ...group.aliasNorms
          ]);

        const trigger =
          longestContainedForm(
            normalized,
            strictForms
          );

        if (trigger) {

          addExpansion({
            trigger,
            forms:
              strictForms,
            kind:
              'strictForms',
            canonical:
              group.canonical
          });
        }

        const directionalTrigger =
          longestContainedForm(
            normalized,
            group.queryAliasNorms
          );

        if (directionalTrigger) {

          addExpansion({
            trigger:
              directionalTrigger,

            forms:
              strictForms,

            kind:
              'directionalForms',

            canonical:
              group.canonical
          });
        }
      }


      for (
        const group
        of this.intentGroups
      ) {

        const intentForms =
          unique([
            group.canonicalNorm,
            ...group.termNorms
          ]);

        const trigger =
          longestContainedForm(
            normalized,
            intentForms
          );

        if (trigger) {

          addExpansion({
            trigger,
            forms:
              intentForms,
            kind:
              'intentForms',
            canonical:
              group.canonical
          });
        }
      }


      const concepts = [

        ...[
          ...tokenConcepts.values()
        ]
          .filter(
            concept =>
              !concept
                .queryTokens
                .some(
                  token =>
                    consumedTokens.has(
                      token
                    )
                )
          ),

        ...phraseConcepts.values()
      ];

      return {
        raw:
          rawQuery,

        normalized,

        rawTokens,

        tokens,

        concepts,

        lastToken:
          tokens[
            tokens.length - 1
          ]
          ||
          ''
      };
    }


    conceptAllowsFuzzy(
      concept,
      plan
    ) {

      for (
        const product
        of this.products
      ) {

        if (
          this.bestConceptMatch(
            product,
            concept,
            plan,
            {
              allowFuzzy:
                false
            }
          )
        ) {
          return false;
        }
      }

      return true;
    }


    search(rawQuery) {

      const plan =
        this.buildQueryPlan(
          rawQuery
        );

      if (
        !plan.normalized ||
        !plan.concepts.length
      ) {
        return [];
      }

      const conceptPolicies =
        plan.concepts
          .map(
            concept => ({
              concept,

              allowFuzzy:
                this.conceptAllowsFuzzy(
                  concept,
                  plan
                )
            })
          );

      const results = [];

      for (
        const product
        of this.products
      ) {

        const scored =
          this.scoreProduct(
            product,
            plan,
            conceptPolicies
          );

        if (
          scored.score > 0
        ) {

          scored
            .queryOnlyInsideParentheses =
              queryOnlyInsideParentheses(
                product.title,
                plan.normalized,
                this.stopwords
              );

          results.push(scored);
        }
      }

      const scoreGroupCounts =
        new Map();

      for (
        const result
        of results
      ) {

        const key =
          String(result.score);

        scoreGroupCounts.set(
          key,
          (
            scoreGroupCounts.get(key) ||
            0
          )
          +
          1
        );
      }

      results.sort(
        (a, b) => {

          if (
            b.score !==
            a.score
          ) {

            return (
              b.score -
              a.score
            );
          }

          if (
            a.product.available !==
            b.product.available
          ) {

            return a.product.available
              ? -1
              : 1;
          }

          if (
            a.queryOnlyInsideParentheses !==
            b.queryOnlyInsideParentheses
          ) {

            return a.queryOnlyInsideParentheses
              ? 1
              : -1;
          }

          const tieCount =
            scoreGroupCounts.get(
              String(a.score)
            )
            ||
            0;

          if (
            tieCount >=
            BEST_SELLING_TIE_THRESHOLD &&
            a.product.available &&
            b.product.available
          ) {

            const rankA =
              Number.isFinite(
                a.product.bestSellingRank
              )
                ? a.product.bestSellingRank
                : 999999;

            const rankB =
              Number.isFinite(
                b.product.bestSellingRank
              )
                ? b.product.bestSellingRank
                : 999999;

            if (
              rankA !== rankB
            ) {
              return rankA - rankB;
            }
          }

          return a
            .product
            .title
            .localeCompare(
              b.product.title,
              this.collatorLocale,
              {
                sensitivity:
                  'base'
              }
            );
        }
      );

      return results;
    }


    scoreProduct(
      product,
      plan,
      conceptPolicies
    ) {

      let score = 0;

      const reasons = [];

      let matchedConcepts = 0;

      for (
        const policy
        of conceptPolicies
      ) {

        const concept =
          policy.concept;

        const best =
          this.bestConceptMatch(
            product,
            concept,
            plan,
            {
              allowFuzzy:
                policy.allowFuzzy
            }
          );

        if (!best) {
          continue;
        }

        matchedConcepts += 1;

        score += best.points;

        reasons.push({
          ...best.reason,

          concept:
            concept.label ||
            concept.queryForm
        });
      }

      if (
        plan.concepts.length > 1
      ) {

        const coverage =
          matchedConcepts /
          plan.concepts.length;

        if (coverage === 1) {

          score += 100;

          reasons.push({
            field: 'Consulta',
            type: 'cobertura completa',
            value:
              `${matchedConcepts}/${plan.concepts.length} conceptos`,
            concept:
              plan.normalized,
            points: 100
          });

        } else if (
          coverage >= 0.66
        ) {

          score += 45;

          reasons.push({
            field: 'Consulta',
            type: 'cobertura alta',
            value:
              `${matchedConcepts}/${plan.concepts.length} conceptos`,
            concept:
              plan.normalized,
            points: 45
          });
        }
      }

      if (
        plan.concepts.length >= 3 &&
        matchedConcepts === 1
      ) {
        score *= 0.75;
      }

      reasons.sort(
        (a, b) =>
          b.points - a.points
      );

      return {
        product,

        score:
          Math.round(score),

        matchedConcepts,

        totalConcepts:
          plan.concepts.length,

        reasons:
          reasons.slice(
            0,
            8
          )
      };
    }


    bestConceptMatch(
      product,
      concept,
      plan,
      {
        allowFuzzy = true
      } = {}
    ) {

      const candidates = [];

      const direct =
        this.bestDirectMatch(
          product,
          concept.queryForm,
          plan,
          {
            allowFuzzy
          }
        );

      if (direct) {
        candidates.push(direct);
      }

      if (
        concept
          .strictForms
          .length
      ) {

        const strict =
          this.bestAlternativeMatch(
            product,
            concept.strictForms,
            STRICT_ALIAS_WEIGHTS,
            'sinónimo'
          );

        if (strict) {
          candidates.push(strict);
        }
      }

      if (
        concept
          .directionalForms
          .length
      ) {

        const directional =
          this.bestAlternativeMatch(
            product,
            concept.directionalForms,
            DIRECTIONAL_ALIAS_WEIGHTS,
            'alias dirigido'
          );

        if (directional) {
          candidates.push(
            directional
          );
        }
      }

      if (
        concept
          .intentForms
          .length
      ) {

        const intent =
          this.bestAlternativeMatch(
            product,
            concept.intentForms,
            INTENT_WEIGHTS,
            'intención relacionada'
          );

        if (intent) {
          candidates.push(intent);
        }
      }

      if (!candidates.length) {
        return null;
      }

      candidates.sort(
        (a, b) =>
          b.points -
          a.points
      );

      return candidates[0];
    }


    bestDirectMatch(
      product,
      queryForm,
      plan,
      {
        allowFuzzy = true
      } = {}
    ) {

      if (!queryForm) {
        return null;
      }

      const queryTokens =
        tokenizeNormalized(
          queryForm
        );

      const singleToken =
        queryTokens.length === 1;

      let best = null;

      for (
        const fieldName
        of FIELD_ORDER
      ) {

        const config =
          FIELD_CONFIG[fieldName];

        const field =
          product
            ._prepared[fieldName];

        if (!field.text) {
          continue;
        }

        if (
          field
            .segments
            .some(
              segment =>
                containsWholePhrase(
                  segment,
                  queryForm
                )
            )
        ) {

          best =
            this.pickBetter(
              best,
              {
                points:
                  config.phrase,

                reason: {
                  field:
                    config.label,

                  type:
                    singleToken
                      ? 'coincidencia exacta'
                      : 'frase exacta',

                  value:
                    queryForm,

                  points:
                    config.phrase
                }
              }
            );

          continue;
        }

        if (
          singleToken &&
          field
            .segments
            .some(
              segment =>
                containsConservativePluralVariant(
                  segment,
                  queryForm
                )
            )
        ) {

          best =
            this.pickBetter(
              best,
              {
                points:
                  config.phrase,

                reason: {
                  field:
                    config.label,

                  type:
                    'singular/plural',

                  value:
                    queryForm,

                  points:
                    config.phrase
                }
              }
            );

          continue;
        }

        if (
          !singleToken &&
          allTokensPresent(
            field.tokens,
            queryForm
          )
        ) {

          best =
            this.pickBetter(
              best,
              {
                points:
                  config.token,

                reason: {
                  field:
                    config.label,

                  type:
                    'términos completos',

                  value:
                    queryForm,

                  points:
                    config.token
                }
              }
            );

          continue;
        }

        if (
          singleToken &&
          config.prefix !== false &&
          queryForm ===
          plan.lastToken &&
          queryForm.length >= 3 &&
          startsWithToken(
            field.tokens,
            queryForm
          )
        ) {

          const points =
            Math.round(
              config.token *
              0.55
            );

          best =
            this.pickBetter(
              best,
              {
                points,

                reason: {
                  field:
                    config.label,

                  type:
                    'prefijo',

                  value:
                    queryForm,

                  points
                }
              }
            );

          continue;
        }

        if (
          allowFuzzy &&
          singleToken &&
          config.fuzzy
        ) {

          const threshold =
            fuzzyThreshold(
              queryForm
            );

          if (threshold > 0) {

            const fuzzy =
              this.bestFuzzyToken(
                queryForm,
                field.tokens,
                threshold
              );

            if (fuzzy) {

              const points =
                Math.round(
                  config.token *
                  (
                    fuzzy.distance === 1
                      ? 0.62
                      : 0.48
                  )
                );

              best =
                this.pickBetter(
                  best,
                  {
                    points,

                    reason: {
                      field:
                        config.label,

                      type:
                        `aprox. → ${fuzzy.token}`,

                      value:
                        queryForm,

                      points
                    }
                  }
                );
            }
          }
        }
      }

      const collectionMatch =
        this.bestDirectCollectionMatch(
          product,
          queryForm
        );

      if (collectionMatch) {

        best =
          this.pickBetter(
            best,
            collectionMatch
          );
      }

      return best;
    }


    bestDirectCollectionMatch(
      product,
      queryForm
    ) {

      const collections =
        product
          ._preparedCollections ||
        [];

      if (!collections.length) {
        return null;
      }

      const queryTokens =
        tokenizeNormalized(
          queryForm
        );

      const singleToken =
        queryTokens.length === 1;

      for (
        const collection
        of collections
      ) {

        if (
          containsWholePhrase(
            collection.normalizedTitle,
            queryForm
          )
        ) {

          return {
            points:
              COLLECTION_MATCH_WEIGHT,

            reason: {
              field: 'Colección',
              type: 'coincidencia directa',
              value:
                collection.title,
              points:
                COLLECTION_MATCH_WEIGHT
            }
          };
        }

        if (
          singleToken &&
          containsConservativePluralVariant(
            collection.normalizedTitle,
            queryForm
          )
        ) {

          return {
            points:
              COLLECTION_MATCH_WEIGHT,

            reason: {
              field: 'Colección',
              type: 'singular/plural',
              value:
                collection.title,
              points:
                COLLECTION_MATCH_WEIGHT
            }
          };
        }

        if (
          !singleToken &&
          queryTokens.every(
            token =>
              collection
                .tokens
                .has(token)
          )
        ) {

          return {
            points:
              COLLECTION_MATCH_WEIGHT,

            reason: {
              field: 'Colección',
              type: 'términos directos',
              value:
                collection.title,
              points:
                COLLECTION_MATCH_WEIGHT
            }
          };
        }
      }

      return null;
    }


    bestAlternativeMatch(
      product,
      forms,
      weights,
      typeLabel
    ) {

      let best = null;

      for (
        const fieldName
        of FIELD_ORDER
      ) {

        const weight =
          weights[fieldName] ||
          0;

        if (weight <= 0) {
          continue;
        }

        const field =
          product
            ._prepared[fieldName];

        if (!field.text) {
          continue;
        }

        for (const form of forms) {

          if (!form) {
            continue;
          }

          let matched = false;
          let matchType =
            typeLabel;

          if (
            field
              .segments
              .some(
                segment =>
                  containsWholePhrase(
                    segment,
                    form
                  )
              )
          ) {

            matched = true;

          } else if (
            tokenizeNormalized(
              form
            ).length > 1 &&
            allTokensPresent(
              field.tokens,
              form
            )
          ) {

            matched = true;

            matchType =
              `${typeLabel} · términos`;
          }

          if (!matched) {
            continue;
          }

          best =
            this.pickBetter(
              best,
              {
                points:
                  weight,

                reason: {
                  field:
                    FIELD_CONFIG[
                      fieldName
                    ].label,

                  type:
                    matchType,

                  value:
                    form,

                  points:
                    weight
                }
              }
            );
        }
      }

      return best;
    }


    pickBetter(
      current,
      candidate
    ) {

      if (!candidate) {
        return current;
      }

      if (!current) {
        return candidate;
      }

      return candidate.points >
        current.points
        ? candidate
        : current;
    }


    bestFuzzyToken(
      queryToken,
      candidateTokens,
      threshold
    ) {

      let best = null;

      for (
        const candidate
        of candidateTokens
      ) {

        if (
          candidate.length < 5
        ) {
          continue;
        }

        if (
          Math.abs(
            candidate.length -
            queryToken.length
          ) > threshold
        ) {
          continue;
        }

        const distance =
          levenshteinWithin(
            queryToken,
            candidate,
            threshold
          );

        if (
          distance === null ||
          distance === 0
        ) {
          continue;
        }

        if (
          !best ||
          distance <
          best.distance
        ) {

          best = {
            token:
              candidate,
            distance
          };

          if (distance === 1) {
            break;
          }
        }
      }

      return best;
    }


    /* =======================================================
       COLECCIONES RELACIONADAS
       ======================================================= */

    collectionConceptAllowsFuzzy(
      concept
    ) {

      for (
        const collection
        of this.collections
      ) {

        if (
          this.scoreCollectionConcept(
            collection,
            concept,
            {
              allowFuzzy:
                false
            }
          ) > 0
        ) {
          return false;
        }
      }

      return true;
    }


    scoreCollectionConcept(
      collection,
      concept,
      {
        allowFuzzy = true
      } = {}
    ) {

      const prepared =
        collection._prepared;

      const title =
        prepared.title;

      const tokens =
        prepared.tokens;

      const searchTerms =
        prepared.searchTerms ||
        [];

      const searchTermTokens =
        prepared.searchTermTokens ||
        new Set();

      if (
        containsWholePhrase(
          title,
          concept.queryForm
        )
      ) {
        return 120;
      }

      if (
        searchTerms.some(
          term =>
            containsWholePhrase(
              term,
              concept.queryForm
            )
        )
      ) {
        return COLLECTION_SEARCH_TERM_WEIGHT;
      }

      if (
        concept.queryTokens.length === 1 &&
        containsConservativePluralVariant(
          title,
          concept.queryForm
        )
      ) {
        return 110;
      }

      if (
        concept.queryTokens.length === 1 &&
        searchTerms.some(
          term =>
            containsConservativePluralVariant(
              term,
              concept.queryForm
            )
        )
      ) {
        return 105;
      }

      if (
        concept.queryTokens.length > 1 &&
        allTokensPresent(
          tokens,
          concept.queryForm
        )
      ) {
        return 100;
      }

      if (
        concept.queryTokens.length > 1 &&
        allTokensPresent(
          searchTermTokens,
          concept.queryForm
        )
      ) {
        return 95;
      }

      for (
        const form
        of concept.strictForms
      ) {

        if (
          containsWholePhrase(
            title,
            form
          )
        ) {
          return 90;
        }

        if (
          searchTerms.some(
            term =>
              containsWholePhrase(
                term,
                form
              )
          )
        ) {
          return 88;
        }
      }

      for (
        const form
        of concept.directionalForms
      ) {

        if (
          containsWholePhrase(
            title,
            form
          )
        ) {
          return 70;
        }

        if (
          searchTerms.some(
            term =>
              containsWholePhrase(
                term,
                form
              )
          )
        ) {
          return 68;
        }
      }

      if (
        concept.queryTokens.length === 1
      ) {

        const token =
          concept.queryTokens[0];

        if (
          token.length >= 3 &&
          startsWithToken(
            tokens,
            token
          )
        ) {
          return 40;
        }

        if (
          token.length >= 3 &&
          startsWithToken(
            searchTermTokens,
            token
          )
        ) {
          return 38;
        }
      }

      if (
        allowFuzzy &&
        concept.queryTokens.length === 1
      ) {

        const token =
          concept.queryTokens[0];

        const threshold =
          fuzzyThreshold(token);

        if (threshold > 0) {

          if (
            this.bestFuzzyToken(
              token,
              tokens,
              threshold
            )
          ) {
            return 30;
          }

          if (
            this.bestFuzzyToken(
              token,
              searchTermTokens,
              threshold
            )
          ) {
            return 28;
          }
        }
      }

      return 0;
    }


    searchCollections(
      rawQuery,
      limit = null
    ) {

      const plan =
        this.buildQueryPlan(
          rawQuery
        );

      if (!plan.normalized) {
        return [];
      }

      const policies =
        plan.concepts
          .map(
            concept => ({
              concept,

              allowFuzzy:
                this.collectionConceptAllowsFuzzy(
                  concept
                )
            })
          );

      const results = [];

      for (
        const collection
        of this.collections
      ) {

        let score = 0;
        let matchedConcepts = 0;

        for (
          const policy
          of policies
        ) {

          const conceptScore =
            this.scoreCollectionConcept(
              collection,
              policy.concept,
              {
                allowFuzzy:
                  policy.allowFuzzy
              }
            );

          if (
            conceptScore > 0
          ) {

            matchedConcepts += 1;
            score += conceptScore;
          }
        }

        if (
          plan.concepts.length > 1 &&
          matchedConcepts ===
          plan.concepts.length
        ) {
          score += 75;
        }

        if (score > 0) {

          results.push({
            collection,
            score
          });
        }
      }

      results.sort(
        (a, b) => {

          if (
            b.score !==
            a.score
          ) {
            return (
              b.score -
              a.score
            );
          }

          return a
            .collection
            .title
            .localeCompare(
              b.collection.title,
              this.collatorLocale,
              {
                sensitivity:
                  'base'
              }
            );
        }
      );

      return Number.isFinite(limit) &&
        limit > 0
          ? results.slice(
              0,
              limit
            )
          : results;
    }
  }


  /* =========================================================
     APP
     ========================================================= */

  class BTSearchApp {

    constructor(root) {

      this.root =
        root;

      const globalConfig =
        window
          .BT_SEARCH_GLOBAL_CONFIG
        ||
        {};

      this.config = {

        shopDomain:
          root.dataset.shopDomain
          ||
          globalConfig.shopDomain,

        token:
          root.dataset.storefrontToken
          ||
          globalConfig.token,

        apiVersion:
          root.dataset.apiVersion
          ||
          globalConfig.apiVersion
          ||
          DEFAULT_API_VERSION,

        dictionaryUrl:
          root.dataset.dictionaryUrl
          ||
          globalConfig.dictionaryUrl,

        rootUrl:
          root.dataset.rootUrl
          ||
          '/',

        cartAddUrl:
          root.dataset.cartAddUrl
          ||
          '/cart/add.js',

        locale:
          root.dataset.locale
          ||
          'es-ES',

        currency:
          root.dataset.currency
          ||
          'EUR',

        isB2B:
          root.dataset.btB2b ===
          'true'
          ||
          globalConfig.isB2B ===
          true,

        companyLocationId:
          root.dataset.btCompanyLocationId
          ||
          globalConfig.companyLocationId
          ||
          '',

        b2bContextSectionId:
          root.dataset.btB2bContextSectionId
          ||
          globalConfig.b2bContextSectionId
          ||
          B2B_CONTEXT_SECTION_ID,

        b2bIndexSectionId:
          root.dataset.btB2bIndexSectionId
          ||
          globalConfig.b2bIndexSectionId
          ||
          B2B_INDEX_SECTION_ID,

        expectedProducts:
          Number(
            root.dataset.expectedProducts
            ||
            0
          ),

        debug:
          root.dataset.debug ===
          'true',

        perPage:
          Number(
            root.dataset.perPage
            ||
            24
          ),

        predictiveLimit:
          Number(
            root.dataset.predictiveLimit
            ||
            6
          ),

        predictiveLimitDesktop:
          Number(
            root.dataset.predictiveLimitDesktop
            ||
            root.dataset.predictiveLimit
            ||
            5
          ),

        predictiveLimitMobile:
          Number(
            root.dataset.predictiveLimitMobile
            ||
            root.dataset.predictiveLimit
            ||
            4
          ),

        predictiveEnabled:
          root.dataset.predictiveEnabled !==
          'false',

        predictiveMinChars:
          Number(
            root.dataset.predictiveMinChars
            ||
            2
          ),

        showVendor:
          root.dataset.showVendor !==
          'false',

        showRating:
          root.dataset.showRating !==
          'false',

        showQuickBuy:
          root.dataset.showQuickBuy !==
          'false',

        showSecondaryImage:
          root.dataset.showSecondaryImage !==
          'false',

        /*
         * NUEVO:
         *
         * "global-header"
         * = barra situada debajo del header.
         *
         * Cualquier otro valor
         * = página completa.
         */

        surface:
          root.dataset.btSearchSurface
          ||
          'results-page',

        searchPageUrl:
          root.dataset.btSearchPageUrl
          ||
          '/pages/buscador'
      };


      this.ui =
        uiCopyForLocale(
          this.config.locale
        );

      this.collatorLocale =
        collatorLocale(
          this.config.locale
        );

      applyUiDefinitionLabels(
        this.config.locale
      );


      this.input =
        root.querySelector(
          '[data-bt-search-input]'
        );

      this.clearButton =
        root.querySelector(
          '[data-bt-search-clear]'
        );

      this.predictive =
        root.querySelector(
          '[data-bt-search-predictive]'
        );

      this.results =
        root.querySelector(
          '[data-bt-search-results]'
        );

      this.collections =
        root.querySelector(
          '[data-bt-search-collections]'
        );

      this.status =
        root.querySelector(
          '[data-bt-search-status]'
        );

      this.stats =
        root.querySelector(
          '[data-bt-search-stats]'
        );

      this.pagination =
        root.querySelector(
          '[data-bt-search-pagination]'
        );

      this.refreshButton =
        root.querySelector(
          '[data-bt-search-refresh]'
        );

      this.filterOverlay =
        root.querySelector(
          '[data-bt-filter-overlay]'
        );

      this.filterDrawer =
        root.querySelector(
          '[data-bt-filter-drawer]'
        );

      this.loader = null;
      this.engine = null;

      this.currentQuery = '';

      this.baseResults = [];
      this.currentResults = [];

      this.currentPage = 1;

      this.sortMode =
        'relevance';

      this.activePredictiveIndex =
        -1;

      this.lastTrackedQuery =
        '';

      this.openDesktopFilter =
        null;

      this.openMobileFilterSections =
        new Set();

      this.brandFilterSearch =
        '';

      this.activeFilters =
        this.createEmptyFilterState();

      this.runDebounced =
        debounce(
          () =>
            this.runSearch({
              predictive:
                this.config.predictiveEnabled,

              updateHistory:
                false
            }),
          90
        );

      this.trackDebounced =
        debounce(
          () =>
            this.trackSearch(),
          450
        );
    }


    isGlobalHeader() {

      return (
        this.config.surface ===
        'global-header'
      );
    }


    getPredictiveLimit() {

      const isMobile =
        window.matchMedia &&
        window
          .matchMedia(
            '(max-width: 699px)'
          )
          .matches;

      const limit =
        isMobile
          ? this.config
              .predictiveLimitMobile
          : this.config
              .predictiveLimitDesktop;

      return (
        Number.isFinite(limit) &&
        limit > 0
          ? limit
          : this.config
              .predictiveLimit
      );
    }


    goToSearchPage(
      query =
        this.input?.value ||
        ''
    ) {

      const cleanQuery =
        String(query)
          .trim();

      if (!cleanQuery) {
        return;
      }

      const url =
        new URL(
          this.config.searchPageUrl,
          window.location.origin
        );

      url.searchParams.set(
        'q',
        cleanQuery
      );

      window.location.href =
        url.toString();
    }


    /* =======================================================
       ESTADO FILTROS
       ======================================================= */

    createEmptyFilterState() {

      const state = {
        priceMin: null,
        priceMax: null
      };

      for (
        const def
        of FILTER_DEFS
      ) {

        state[def.key] =
          new Set();
      }

      return state;
    }


    resetFiltersState() {

      this.activeFilters =
        this.createEmptyFilterState();

      this.openDesktopFilter =
        null;

      this.brandFilterSearch =
        '';

      this.openMobileFilterSections.clear();
    }


    async init() {

      const buyerContext =
        await resolveBuyerContext(
          this.config
        );

      this.config.isB2B =
        Boolean(
          buyerContext.isB2B
        );

      this.config.companyLocationId =
        normalizeCompanyLocationId(
          buyerContext.companyLocationId
        );

      if (
        !this.config.isB2B &&
        (
          !this.config.token ||
          this.config.token.includes(
            'PEGA_AQUI'
          )
        )
      ) {

        this.showFatal(
          'Falta el Storefront public access token.'
        );

        return;
      }

      this.ensureAuxStyles();

      this.bindEvents();

      this.setStatus(
        this.ui.loadingIndex,
        'loading'
      );

      try {

        this.loader =
          new StorefrontIndexLoader(
            this.config
          );

        const loaded =
          await this.loader.load();

        const prepareStarted =
          perfNow();

        this.engine =
          new BTSearchEngine(
            loaded.products,
            loaded.collections,
            loaded.dictionary,
            this.config.locale
          );

        const prepareMs =
          elapsedSince(
            prepareStarted
          );

        this.updateStats(
          loaded,
          prepareMs
        );

        this.setStatus(
          loaded.cacheState ===
            'stale'
            ? this.ui.readyUpdating
            : this.ui.ready,
          'ready'
        );

        /*
         * La barra global comienza vacía.
         *
         * La página completa sí recupera ?q=
         */

        const initialQuery =
          this.isGlobalHeader()
            ? ''
            : (
                new URL(
                  window.location.href
                )
                  .searchParams
                  .get('q')
                ||
                ''
              );

        if (initialQuery) {

          this.input.value =
            initialQuery;

          this.toggleClear();

          await this.runSearch({
            predictive:
              false,

            updateHistory:
              false
          });

        } else {

          this.renderEmptyState();
        }

      } catch (error) {

        console.error(
          '[BT Search]',
          error
        );

        this.showFatal(
          this.humanizeLoadError(
            error
          )
        );
      }
    }


    /* =======================================================
       ORDENACIÓN
       ======================================================= */

    getSortLabel() {

      return (
        SORT_OPTIONS
          .find(
            option =>
              option.value ===
              this.sortMode
          )
          ?.label
        ||
        this.ui.sortRelevance
      );
    }


    getSortablePrice(product) {

      const amount =
        product
          ?.variant
          ?.price
          ?.amount
        ??
        product
          ?.minPrice
          ?.amount;

      const number =
        Number(amount);

      return Number.isFinite(number)
        ? number
        : null;
    }


    applySort(results) {

      const sorted = [
        ...(results || [])
      ];

      if (
        this.sortMode ===
        'relevance'
      ) {
        return sorted;
      }

      const titleCompare =
        (a, b) =>
          a.product.title
            .localeCompare(
              b.product.title,
              this.collatorLocale,
              {
                sensitivity:
                  'base'
              }
            );

      sorted.sort(
        (a, b) => {

          if (
            a.product.available !==
            b.product.available
          ) {

            return a.product.available
              ? -1
              : 1;
          }

          if (
            this.sortMode ===
            'best-selling'
          ) {

            const rankA =
              Number.isFinite(
                a.product.bestSellingRank
              )
                ? a.product.bestSellingRank
                : 999999;

            const rankB =
              Number.isFinite(
                b.product.bestSellingRank
              )
                ? b.product.bestSellingRank
                : 999999;

            if (
              rankA !== rankB
            ) {
              return rankA - rankB;
            }

            return titleCompare(a, b);
          }

          if (
            this.sortMode ===
              'price-asc'
            ||
            this.sortMode ===
              'price-desc'
          ) {

            const priceA =
              this.getSortablePrice(
                a.product
              );

            const priceB =
              this.getSortablePrice(
                b.product
              );

            if (
              priceA === null &&
              priceB !== null
            ) {
              return 1;
            }

            if (
              priceA !== null &&
              priceB === null
            ) {
              return -1;
            }

            if (
              priceA !== null &&
              priceB !== null &&
              priceA !== priceB
            ) {

              return this.sortMode ===
                'price-asc'
                  ? priceA - priceB
                  : priceB - priceA;
            }

            return titleCompare(a, b);
          }

          if (
            this.sortMode ===
            'title-asc'
          ) {

            return titleCompare(
              a,
              b
            );
          }

          return 0;
        }
      );

      return sorted;
    }


    setSortMode(value) {

      if (
        !SORT_OPTIONS.some(
          option =>
            option.value ===
            value
        )
      ) {
        return;
      }

      if (
        value ===
        this.sortMode
      ) {

        this.closeSortDropdowns();
        return;
      }

      this.sortMode =
        value;

      this.currentPage =
        1;

      this.rebuildCurrentResults();

      this.renderResults();

      if (
        this.isFilterDrawerOpen()
      ) {
        this.renderFilterDrawer();
      }

      this.capture(
        'bt_search_sort_change',
        {
          query:
            this.currentQuery,

          sort:
            this.sortMode,

          sort_label:
            this.getSortLabel(),

          results_count:
            this.currentResults.length,

          surface:
            'results_page'
        }
      );
    }


    /* =======================================================
       FILTROS
       ======================================================= */

    rebuildCurrentResults() {

      this.currentResults =
        this.applySort(
          this.applyFilters(
            this.baseResults
          )
        );
    }


    hasAnyFilters() {

      if (
        this.activeFilters.priceMin !==
        null
        ||
        this.activeFilters.priceMax !==
        null
      ) {
        return true;
      }

      return FILTER_DEFS.some(
        def =>
          this.activeFilters[
            def.key
          ].size > 0
      );
    }


    activeFilterCount() {

      let count =
        FILTER_DEFS
          .reduce(
            (
              total,
              def
            ) =>
              total +
              this.activeFilters[
                def.key
              ].size,
            0
          );

      if (
        this.activeFilters.priceMin !==
        null
        ||
        this.activeFilters.priceMax !==
        null
      ) {
        count += 1;
      }

      return count;
    }


    productMatchesCategory(
      product,
      def,
      selectedSet =
        this.activeFilters[
          def.key
        ]
    ) {

      if (!selectedSet?.size) {
        return true;
      }

      const productSet =
        product
          ._filterSets
          ?.[def.key]
        ||
        new Set();

      const selected = [
        ...selectedSet
      ];

      return def.mode ===
        'or'
          ? selected.some(
              value =>
                productSet.has(value)
            )
          : selected.every(
              value =>
                productSet.has(value)
            );
    }


    matchesFilters(
      result,
      {
        excludeKey = null
      } = {}
    ) {

      const product =
        result.product;

      for (
        const def
        of FILTER_DEFS
      ) {

        if (
          def.key ===
          excludeKey
        ) {
          continue;
        }

        if (
          !this.productMatchesCategory(
            product,
            def
          )
        ) {
          return false;
        }
      }

      if (
        excludeKey !==
        'price'
      ) {

        const min =
          this.activeFilters.priceMin;

        const max =
          this.activeFilters.priceMax;

        if (
          min !== null ||
          max !== null
        ) {

          const price =
            this.getSortablePrice(
              product
            );

          if (price === null) {
            return false;
          }

          if (
            min !== null &&
            price < min
          ) {
            return false;
          }

          if (
            max !== null &&
            price > max
          ) {
            return false;
          }
        }
      }

      return true;
    }


    applyFilters(results) {

      if (
        !this.hasAnyFilters()
      ) {

        return [
          ...(results || [])
        ];
      }

      return (
        results ||
        []
      )
        .filter(
          result =>
            this.matchesFilters(
              result
            )
        );
    }


    getFacetOptions(key) {

      const def =
        FILTER_DEFS.find(
          item =>
            item.key === key
        );

      if (!def) {
        return [];
      }

      const labels =
        new Map();

      for (
        const result
        of this.baseResults
      ) {

        for (
          const raw
          of result.product
            .filterValues
            ?.[key]
          ||
          []
        ) {

          const norm =
            normalizeText(raw);

          if (
            norm &&
            !labels.has(norm)
          ) {
            labels.set(
              norm,
              raw
            );
          }
        }
      }

      const selected =
        this.activeFilters[key];

      const options = [];

      for (
        const [
          norm,
          label
        ]
        of labels.entries()
      ) {

        let count = 0;

        for (
          const result
          of this.baseResults
        ) {

          if (
            !this.matchesFilters(
              result,
              {
                excludeKey:
                  key
              }
            )
          ) {
            continue;
          }

          const productSet =
            result.product
              ._filterSets
              ?.[key]
            ||
            new Set();

          let matches = false;

          if (
            def.mode ===
            'and'
          ) {

            const needed =
              new Set(selected);

            needed.add(norm);

            matches = [
              ...needed
            ]
              .every(
                value =>
                  productSet.has(value)
              );

          } else {

            matches =
              productSet.has(norm);
          }

          if (matches) {
            count += 1;
          }
        }

        options.push({
          norm,
          label,
          count,

          selected:
            selected.has(norm)
        });
      }

      return options
        .sort(
          (a, b) =>
            a.label
              .localeCompare(
                b.label,
                this.collatorLocale,
                {
                  sensitivity:
                    'base'
                }
              )
        );
    }


    getFacetLabel(
      key,
      norm
    ) {

      for (
        const result
        of this.baseResults
      ) {

        for (
          const raw
          of result.product
            .filterValues
            ?.[key]
          ||
          []
        ) {

          if (
            normalizeText(raw) ===
            norm
          ) {
            return raw;
          }
        }
      }

      return norm;
    }


    getPriceBounds() {

      const prices =
        this.baseResults
          .filter(
            result =>
              this.matchesFilters(
                result,
                {
                  excludeKey:
                    'price'
                }
              )
          )
          .map(
            result =>
              this.getSortablePrice(
                result.product
              )
          )
          .filter(
            Number.isFinite
          );

      if (!prices.length) {

        return {
          min: 0,
          max: 0
        };
      }

      return {

        min:
          Math.floor(
            Math.min(...prices)
          ),

        max:
          Math.ceil(
            Math.max(...prices)
          )
      };
    }


    toggleFilterValue(
      key,
      norm
    ) {

      const def =
        FILTER_DEFS.find(
          item =>
            item.key === key
        );

      if (
        !def ||
        !norm
      ) {
        return;
      }

      const set =
        this.activeFilters[key];

      if (
        set.has(norm)
      ) {
        set.delete(norm);
      } else {
        set.add(norm);
      }

      this.currentPage = 1;

      this.rebuildCurrentResults();

      this.renderResults();

      if (
        this.isFilterDrawerOpen()
      ) {
        this.renderFilterDrawer();
      }

      this.capture(
        'bt_search_filter_change',
        {
          query:
            this.currentQuery,

          filter:
            key,

          value:
            this.getFacetLabel(
              key,
              norm
            ),

          selected:
            set.has(norm),

          results_count:
            this.currentResults.length,

          surface:
            'results_page'
        }
      );
    }


    setPriceFilter(
      field,
      rawValue
    ) {

      let value =
        String(
          rawValue ??
          ''
        )
          .trim()
          .replace(
            ',',
            '.'
          );

      let number =
        value === ''
          ? null
          : Number(value);

      if (
        number !== null &&
        (
          !Number.isFinite(number) ||
          number < 0
        )
      ) {
        number = null;
      }

      if (
        field ===
        'min'
      ) {
        this.activeFilters.priceMin =
          number;
      }

      if (
        field ===
        'max'
      ) {
        this.activeFilters.priceMax =
          number;
      }

      if (
        this.activeFilters.priceMin !==
        null
        &&
        this.activeFilters.priceMax !==
        null
        &&
        this.activeFilters.priceMin >
        this.activeFilters.priceMax
      ) {

        const oldMin =
          this.activeFilters.priceMin;

        this.activeFilters.priceMin =
          this.activeFilters.priceMax;

        this.activeFilters.priceMax =
          oldMin;
      }

      this.currentPage = 1;

      this.rebuildCurrentResults();

      this.renderResults();

      if (
        this.isFilterDrawerOpen()
      ) {
        this.renderFilterDrawer();
      }

      this.capture(
        'bt_search_filter_change',
        {
          query:
            this.currentQuery,

          filter:
            'price',

          min:
            this.activeFilters.priceMin,

          max:
            this.activeFilters.priceMax,

          results_count:
            this.currentResults.length,

          surface:
            'results_page'
        }
      );
    }


    clearFilter(
      key,
      norm = null
    ) {

      if (
        key ===
        'price'
      ) {

        this.activeFilters.priceMin =
          null;

        this.activeFilters.priceMax =
          null;

      } else if (
        this.activeFilters[key]
      ) {

        if (norm) {
          this.activeFilters[key]
            .delete(norm);
        } else {
          this.activeFilters[key]
            .clear();
        }
      }

      this.currentPage = 1;

      this.rebuildCurrentResults();

      this.renderResults();

      if (
        this.isFilterDrawerOpen()
      ) {
        this.renderFilterDrawer();
      }
    }


    clearAllFilters({
      track = true
    } = {}) {

      this.resetFiltersState();

      this.currentPage = 1;

      this.rebuildCurrentResults();

      this.renderResults();

      if (
        this.isFilterDrawerOpen()
      ) {
        this.renderFilterDrawer();
      }

      if (track) {

        this.capture(
          'bt_search_filters_clear',
          {
            query:
              this.currentQuery,

            results_count:
              this.currentResults.length,

            surface:
              'results_page'
          }
        );
      }
    }


    /* =======================================================
       ORDENAR HTML
       ======================================================= */

    renderSortOptions() {

      return SORT_OPTIONS
        .map(
          option => `

            <button
              type="button"
              class="btsearch-sort__option ${
                option.value ===
                this.sortMode
                  ? 'is-active'
                  : ''
              }"
              data-bt-sort-value="${escapeHtml(option.value)}"
              role="menuitemradio"
              aria-checked="${
                option.value ===
                this.sortMode
                  ? 'true'
                  : 'false'
              }"
            >

              <span>
                ${escapeHtml(option.label)}
              </span>

              <span
                class="btsearch-sort__check"
                aria-hidden="true"
              >
                ${
                  option.value ===
                  this.sortMode
                    ? '✓'
                    : ''
                }
              </span>

            </button>

          `
        )
        .join('');
    }


    renderSortControl() {

      return `

        <div
          class="btsearch-sort"
          data-bt-sort
        >

          <span class="btsearch-sort__prefix">
            ${this.ui.sortBy}:
          </span>

          <div class="btsearch-sort__dropdown">

            <button
              type="button"
              class="btsearch-sort__toggle"
              data-bt-sort-toggle
              aria-haspopup="menu"
              aria-expanded="false"
            >

              <span>
                ${escapeHtml(this.getSortLabel())}
              </span>

              ${this.chevronIcon()}

            </button>

            <div
              class="btsearch-sort__menu"
              data-bt-sort-menu
              role="menu"
              hidden
            >
              ${this.renderSortOptions()}
            </div>

          </div>

        </div>

      `;
    }


    renderMobileControls() {

      const count =
        this.activeFilterCount();

      return `

        <div class="btsearch-mobile-controls">

          <button
            type="button"
            class="btsearch-mobile-control"
            data-bt-filter-drawer-open
          >

            ${this.filterIcon()}

            <span>
              ${this.ui.filter}
            </span>

            ${
              count
                ? `
                  <span class="btsearch-mobile-control__count">
                    ${count}
                  </span>
                `
                : ''
            }

          </button>


          <div
            class="btsearch-mobile-sort"
            data-bt-sort
          >

            <button
              type="button"
              class="btsearch-mobile-control btsearch-mobile-sort__toggle"
              data-bt-sort-toggle
              aria-haspopup="menu"
              aria-expanded="false"
            >

              <span>
                ${this.ui.sortBy}
              </span>

              ${this.chevronIcon()}

            </button>

            <div
              class="btsearch-sort__menu"
              data-bt-sort-menu
              role="menu"
              hidden
            >
              ${this.renderSortOptions()}
            </div>

          </div>

        </div>

      `;
    }


    /* =======================================================
       FILTROS PC
       ======================================================= */

    renderDesktopFilter(def) {

      let options =
        this.getFacetOptions(
          def.key
        );

      if (
        def.searchable &&
        this.brandFilterSearch
      ) {

        const needle =
          normalizeText(
            this.brandFilterSearch
          );

        options =
          options.filter(
            option =>
              normalizeText(
                option.label
              )
                .includes(needle)
          );
      }

      const selectedCount =
        this.activeFilters[
          def.key
        ].size;

      const open =
        this.openDesktopFilter ===
        def.key;

      return `

        <div
          class="btsearch-filter ${
            selectedCount
              ? 'has-selection'
              : ''
          } ${
            open
              ? 'is-open'
              : ''
          }"
          data-bt-filter="${escapeHtml(def.key)}"
        >

          <button
            type="button"
            class="btsearch-filter__toggle"
            data-bt-filter-toggle="${escapeHtml(def.key)}"
            aria-expanded="${
              open
                ? 'true'
                : 'false'
            }"
          >

            <span>
              ${escapeHtml(def.label)}
            </span>

            ${
              selectedCount
                ? `
                  <span class="btsearch-filter__count">
                    ${selectedCount}
                  </span>
                `
                : ''
            }

            ${this.chevronIcon()}

          </button>


          <div
            class="btsearch-filter__menu ${
              def.searchable
                ? 'btsearch-filter__menu--wide'
                : ''
            }"
            data-bt-filter-menu="${escapeHtml(def.key)}"
            ${
              open
                ? ''
                : 'hidden'
            }
          >

            ${
              def.searchable
                ? this.renderBrandSearch()
                : ''
            }

            <div class="btsearch-filter-options">
              ${this.renderFilterOptions(def, options)}
            </div>

          </div>

        </div>

      `;
    }


    renderPriceDesktop() {

      const open =
        this.openDesktopFilter ===
        'price';

      const selected =
        this.activeFilters.priceMin !==
        null
        ||
        this.activeFilters.priceMax !==
        null;

      return `

        <div
          class="btsearch-filter ${
            selected
              ? 'has-selection'
              : ''
          } ${
            open
              ? 'is-open'
              : ''
          }"
          data-bt-filter="price"
        >

          <button
            type="button"
            class="btsearch-filter__toggle"
            data-bt-filter-toggle="price"
            aria-expanded="${
              open
                ? 'true'
                : 'false'
            }"
          >

            <span>
              ${this.ui.price}
            </span>

            ${
              selected
                ? `
                  <span class="btsearch-filter__count">
                    1
                  </span>
                `
                : ''
            }

            ${this.chevronIcon()}

          </button>

          <div
            class="btsearch-filter__menu"
            data-bt-filter-menu="price"
            ${
              open
                ? ''
                : 'hidden'
            }
          >
            ${this.renderPriceFields()}
          </div>

        </div>

      `;
    }


    renderFilterBar() {

      return `

        <div class="btsearch-filterbar">

          <div class="btsearch-filterbar__title">

            ${this.filterIcon()}

            <span>
              ${this.ui.filterBy}
            </span>

          </div>

          ${
            FILTER_DEFS
              .map(
                def =>
                  this.renderDesktopFilter(
                    def
                  )
              )
              .join('')
          }

          ${this.renderPriceDesktop()}

          <button
            type="button"
            class="btsearch-filterbar__clear"
            data-bt-clear-filters
            ${
              this.hasAnyFilters()
                ? ''
                : 'hidden'
            }
          >
            ${this.ui.clearFilters}
          </button>

        </div>

      `;
    }


    renderBrandSearch() {

      return `

        <div class="btsearch-filter-search">

          <div class="btsearch-filter-search__field">

            <span
              class="btsearch-filter-search__icon"
              aria-hidden="true"
            >
              ${this.searchIcon()}
            </span>

            <input
              type="text"
              class="btsearch-filter-search__input"
              data-bt-brand-search
              value="${escapeHtml(this.brandFilterSearch)}"
              placeholder="${escapeHtml(this.ui.searchBrand)}"
              autocomplete="off"
            >

          </div>

        </div>

      `;
    }


    renderFilterOptions(
      def,
      options =
        this.getFacetOptions(
          def.key
        )
    ) {

      if (!options.length) {

        return `

          <div class="btsearch-filter-empty">
            ${this.ui.noOptions}
          </div>

        `;
      }

      return options
        .map(
          option => {

            const disabled =
              option.count === 0 &&
              !option.selected;

            return `

              <button
                type="button"
                class="btsearch-filter-option ${
                  option.selected
                    ? 'is-selected'
                    : ''
                } ${
                  disabled
                    ? 'is-disabled'
                    : ''
                }"
                data-bt-filter-option
                data-filter-key="${escapeHtml(def.key)}"
                data-filter-value="${escapeHtml(option.norm)}"
                ${
                  disabled
                    ? 'disabled'
                    : ''
                }
              >

                <span
                  class="btsearch-filter-option__checkbox"
                  aria-hidden="true"
                >
                  ${this.checkIcon()}
                </span>

                <span class="btsearch-filter-option__label">
                  ${escapeHtml(option.label)}
                </span>

                <span class="btsearch-filter-option__products">
                  (${option.count})
                </span>

              </button>

            `;
          }
        )
        .join('');
    }


    renderPriceFields() {

      const bounds =
        this.getPriceBounds();

      return `

        <div class="btsearch-price-filter">

          <div class="btsearch-price-filter__range">

            <div class="btsearch-price-filter__field">

              <label>
                ${this.ui.from}
              </label>

              <div class="btsearch-price-filter__input-wrap">

                <input
                  type="number"
                  min="0"
                  step="0.01"
                  class="btsearch-price-filter__input"
                  data-bt-price-field="min"
                  value="${
                    this.activeFilters.priceMin
                    ??
                    ''
                  }"
                  placeholder="${bounds.min}"
                >

                <span class="btsearch-price-filter__currency">
                  €
                </span>

              </div>

            </div>


            <div class="btsearch-price-filter__field">

              <label>
                ${this.ui.to}
              </label>

              <div class="btsearch-price-filter__input-wrap">

                <input
                  type="number"
                  min="0"
                  step="0.01"
                  class="btsearch-price-filter__input"
                  data-bt-price-field="max"
                  value="${
                    this.activeFilters.priceMax
                    ??
                    ''
                  }"
                  placeholder="${bounds.max}"
                >

                <span class="btsearch-price-filter__currency">
                  €
                </span>

              </div>

            </div>

          </div>


          <div class="btsearch-price-filter__limits">

            ${this.ui.availableRange}:
            ${escapeHtml(
              formatMoney(
                bounds.min,
                this.config.currency,
                this.config.locale
              )
            )}
            –
            ${escapeHtml(
              formatMoney(
                bounds.max,
                this.config.currency,
                this.config.locale
              )
            )}

          </div>

        </div>

      `;
    }


    /* =======================================================
       CHIPS
       ======================================================= */

    renderActiveFilters() {

      if (
        !this.hasAnyFilters()
      ) {
        return '';
      }

      const chips = [];

      for (
        const def
        of FILTER_DEFS
      ) {

        for (
          const norm
          of this.activeFilters[
            def.key
          ]
        ) {

          chips.push(`

            <button
              type="button"
              class="btsearch-filter-chip"
              data-bt-filter-chip
              data-filter-key="${escapeHtml(def.key)}"
              data-filter-value="${escapeHtml(norm)}"
            >

              <span>
                ${escapeHtml(
                  this.getFacetLabel(
                    def.key,
                    norm
                  )
                )}
              </span>

              <span
                class="btsearch-filter-chip__x"
                aria-hidden="true"
              >
                ×
              </span>

            </button>

          `);
        }
      }

      const min =
        this.activeFilters.priceMin;

      const max =
        this.activeFilters.priceMax;

      if (
        min !== null ||
        max !== null
      ) {

        let label =
          this.ui.price;

        if (
          min !== null &&
          max !== null
        ) {

          label =
            `${this.ui.price}: ${formatMoney(
              min,
              this.config.currency,
              this.config.locale
            )} – ${formatMoney(
              max,
              this.config.currency,
              this.config.locale
            )}`;

        } else if (
          min !== null
        ) {

          label =
            `${this.ui.priceFrom} ${formatMoney(
              min,
              this.config.currency,
              this.config.locale
            )}`;

        } else {

          label =
            `${this.ui.priceTo} ${formatMoney(
              max,
              this.config.currency,
              this.config.locale
            )}`;
        }

        chips.push(`

          <button
            type="button"
            class="btsearch-filter-chip"
            data-bt-filter-chip
            data-filter-key="price"
          >

            <span>
              ${escapeHtml(label)}
            </span>

            <span
              class="btsearch-filter-chip__x"
              aria-hidden="true"
            >
              ×
            </span>

          </button>

        `);
      }

      return `

        <div class="btsearch-active-filters">

          ${chips.join('')}

          <button
            type="button"
            class="btsearch-active-filters__clear"
            data-bt-clear-filters
          >
            ${this.ui.clearFilters}
          </button>

        </div>

      `;
    }


    /* =======================================================
       DRAWER MÓVIL
       ======================================================= */

    renderMobileAccordion(def) {

      const open =
        this.openMobileFilterSections.has(
          def.key
        );

      let options =
        this.getFacetOptions(
          def.key
        );

      if (
        def.searchable &&
        this.brandFilterSearch
      ) {

        const needle =
          normalizeText(
            this.brandFilterSearch
          );

        options =
          options.filter(
            option =>
              normalizeText(
                option.label
              )
                .includes(needle)
          );
      }

      const count =
        this.activeFilters[
          def.key
        ].size;

      return `

        <div
          class="btsearch-filter-accordion ${
            open
              ? 'is-open'
              : ''
          }"
          data-bt-filter-accordion="${escapeHtml(def.key)}"
        >

          <button
            type="button"
            class="btsearch-filter-accordion__toggle"
            data-bt-filter-accordion-toggle="${escapeHtml(def.key)}"
            aria-expanded="${
              open
                ? 'true'
                : 'false'
            }"
          >

            <span class="btsearch-filter-accordion__toggle-main">

              <span>
                ${escapeHtml(def.label)}
              </span>

              ${
                count
                  ? `
                    <span class="btsearch-filter__count">
                      ${count}
                    </span>
                  `
                  : ''
              }

            </span>

            ${this.chevronIcon()}

          </button>

          <div
            class="btsearch-filter-accordion__content"
            ${
              open
                ? ''
                : 'hidden'
            }
          >

            ${
              def.searchable
                ? this.renderBrandSearch()
                : ''
            }

            <div class="btsearch-filter-options">
              ${this.renderFilterOptions(def, options)}
            </div>

          </div>

        </div>

      `;
    }


    renderMobilePriceAccordion() {

      const open =
        this.openMobileFilterSections.has(
          'price'
        );

      const selected =
        this.activeFilters.priceMin !==
        null
        ||
        this.activeFilters.priceMax !==
        null;

      return `

        <div
          class="btsearch-filter-accordion ${
            open
              ? 'is-open'
              : ''
          }"
          data-bt-filter-accordion="price"
        >

          <button
            type="button"
            class="btsearch-filter-accordion__toggle"
            data-bt-filter-accordion-toggle="price"
            aria-expanded="${
              open
                ? 'true'
                : 'false'
            }"
          >

            <span class="btsearch-filter-accordion__toggle-main">

              <span>
                ${this.ui.price}
              </span>

              ${
                selected
                  ? `
                    <span class="btsearch-filter__count">
                      1
                    </span>
                  `
                  : ''
              }

            </span>

            ${this.chevronIcon()}

          </button>

          <div
            class="btsearch-filter-accordion__content"
            ${
              open
                ? ''
                : 'hidden'
            }
          >
            ${this.renderPriceFields()}
          </div>

        </div>

      `;
    }


    renderFilterDrawer() {

      if (!this.filterDrawer) {
        return;
      }

      this.filterDrawer.innerHTML = `

        <div class="btsearch-filter-drawer__header">

          <h2 class="btsearch-filter-drawer__title">
            ${this.ui.filters}
          </h2>

          <div class="btsearch-filter-drawer__header-actions">

            <button
              type="button"
              class="btsearch-filter-drawer__clear"
              data-bt-clear-filters
              ${
                this.hasAnyFilters()
                  ? ''
                  : 'hidden'
              }
            >
              ${this.ui.clearFilters}
            </button>

            <button
              type="button"
              class="btsearch-filter-drawer__close"
              data-bt-filter-drawer-close
              aria-label="${escapeHtml(this.ui.closeFilters)}"
            >
              ${this.closeIcon()}
            </button>

          </div>

        </div>

        <div class="btsearch-filter-drawer__body">

          ${
            FILTER_DEFS
              .map(
                def =>
                  this.renderMobileAccordion(
                    def
                  )
              )
              .join('')
          }

          ${this.renderMobilePriceAccordion()}

        </div>

        <div class="btsearch-filter-drawer__footer">

          <button
            type="button"
            class="btsearch-filter-drawer__apply"
            data-bt-filter-drawer-apply
          >
            ${this.ui.view}
            ${this.currentResults.length}
            ${
              this.currentResults.length === 1
                ? this.ui.resultSingular
                : this.ui.resultPlural
            }
          </button>

        </div>

      `;
    }


    openFilterDrawer() {

      if (
        !this.filterDrawer ||
        !this.filterOverlay
      ) {
        return;
      }

      this.closeSortDropdowns();
      this.closeFilterMenus();

      this.renderFilterDrawer();

      this.filterOverlay.hidden =
        false;

      this.filterDrawer.setAttribute(
        'aria-hidden',
        'false'
      );

      document
        .documentElement
        .classList
        .add(
          'btsearch-filter-drawer-open'
        );

      requestAnimationFrame(
        () => {

          this.filterOverlay
            .classList
            .add(
              'is-visible'
            );

          this.filterDrawer
            .classList
            .add(
              'is-open'
            );
        }
      );
    }


    closeFilterDrawer() {

      if (
        !this.filterDrawer ||
        !this.filterOverlay
      ) {
        return;
      }

      this.filterOverlay
        .classList
        .remove(
          'is-visible'
        );

      this.filterDrawer
        .classList
        .remove(
          'is-open'
        );

      this.filterDrawer.setAttribute(
        'aria-hidden',
        'true'
      );

      document
        .documentElement
        .classList
        .remove(
          'btsearch-filter-drawer-open'
        );

      setTimeout(
        () => {

          if (
            !this.filterDrawer
              .classList
              .contains(
                'is-open'
              )
          ) {
            this.filterOverlay.hidden =
              true;
          }
        },
        220
      );
    }


    isFilterDrawerOpen() {

      return Boolean(
        this.filterDrawer
          ?.classList
          .contains(
            'is-open'
          )
      );
    }


    /* =======================================================
       MENÚS
       ======================================================= */

    toggleSortDropdown(toggle) {

      const wrapper =
        toggle
          ?.closest(
            '[data-bt-sort]'
          );

      if (!wrapper) {
        return;
      }

      const menu =
        wrapper
          .querySelector(
            '[data-bt-sort-menu]'
          );

      if (!menu) {
        return;
      }

      const opening =
        menu.hidden;

      this.closeSortDropdowns(
        wrapper
      );

      this.closeFilterMenus();

      menu.hidden =
        !opening;

      toggle.setAttribute(
        'aria-expanded',
        opening
          ? 'true'
          : 'false'
      );

      wrapper
        .classList
        .toggle(
          'is-open',
          opening
        );
    }


    closeSortDropdowns(
      except = null
    ) {

      this.root
        .querySelectorAll(
          '[data-bt-sort]'
        )
        .forEach(
          wrapper => {

            if (
              except &&
              wrapper === except
            ) {
              return;
            }

            const menu =
              wrapper
                .querySelector(
                  '[data-bt-sort-menu]'
                );

            const toggle =
              wrapper
                .querySelector(
                  '[data-bt-sort-toggle]'
                );

            if (menu) {
              menu.hidden = true;
            }

            if (toggle) {

              toggle.setAttribute(
                'aria-expanded',
                'false'
              );
            }

            wrapper
              .classList
              .remove(
                'is-open'
              );
          }
        );
    }


    toggleFilterMenu(toggle) {

      const key =
        toggle
          ?.dataset
          .btFilterToggle;

      const wrapper =
        toggle
          ?.closest(
            '[data-bt-filter]'
          );

      if (
        !key ||
        !wrapper
      ) {
        return;
      }

      const menu =
        wrapper
          .querySelector(
            '[data-bt-filter-menu]'
          );

      const opening =
        menu?.hidden;

      this.closeSortDropdowns();

      this.openDesktopFilter =
        opening
          ? key
          : null;

      this.closeFilterMenus(
        wrapper
      );

      wrapper
        .classList
        .toggle(
          'is-open',
          Boolean(opening)
        );

      toggle.setAttribute(
        'aria-expanded',
        opening
          ? 'true'
          : 'false'
      );

      if (menu) {
        menu.hidden =
          !opening;
      }

      if (
        opening &&
        key === 'vendor'
      ) {

        setTimeout(
          () =>
            menu
              .querySelector(
                '[data-bt-brand-search]'
              )
              ?.focus(),
          0
        );
      }
    }


    closeFilterMenus(
      except = null
    ) {

      this.root
        .querySelectorAll(
          '[data-bt-filter]'
        )
        .forEach(
          wrapper => {

            if (
              except &&
              wrapper === except
            ) {
              return;
            }

            const menu =
              wrapper
                .querySelector(
                  '[data-bt-filter-menu]'
                );

            const toggle =
              wrapper
                .querySelector(
                  '[data-bt-filter-toggle]'
                );

            if (menu) {
              menu.hidden = true;
            }

            if (toggle) {

              toggle.setAttribute(
                'aria-expanded',
                'false'
              );
            }

            wrapper
              .classList
              .remove(
                'is-open'
              );
          }
        );

      if (!except) {
        this.openDesktopFilter = null;
      }
    }


    /* =======================================================
       CSS AUXILIAR
       ======================================================= */

    ensureAuxStyles() {

      if (
        document.getElementById(
          'bt-search-aux-styles'
        )
      ) {
        return;
      }

      const style =
        document.createElement(
          'style'
        );

      style.id =
        'bt-search-aux-styles';

      style.textContent = `

        .btsearch-results-head {
          position: relative;
          z-index: 40;
        }

        .btsearch-sort {
          display: flex;
          align-items: center;
          gap: 8px;
          flex: 0 0 auto;
        }

        .btsearch-sort__prefix {
          color: rgb(var(--text-color) / .58);
          font-size: 13px;
          white-space: nowrap;
        }

        .btsearch-sort__dropdown,
        .btsearch-mobile-sort {
          position: relative;
        }

        .btsearch-sort__toggle {
          display: inline-flex;
          min-width: 170px;
          min-height: 40px;
          padding: 9px 12px;
          align-items: center;
          justify-content: space-between;
          gap: 14px;
          border: 1px solid rgb(var(--text-color) / .18);
          border-radius: 8px;
          background: #fff;
          color: rgb(var(--text-color));
          font: inherit;
          font-size: 12px;
          cursor: pointer;
        }

        .btsearch-sort.is-open
        .btsearch-sort__toggle {
          border-color: rgb(var(--text-color) / .4);
          box-shadow: 0 0 0 3px rgb(var(--text-color) / .04);
        }

        [data-bt-sort].is-open
        [data-bt-sort-toggle] svg {
          transform: rotate(180deg);
        }

        [data-bt-sort-toggle] svg {
          transition: transform .15s ease;
        }

        .btsearch-sort__menu {
          position: absolute;
          top: calc(100% + 7px);
          right: 0;
          z-index: 120;
          width: 240px;
          padding: 6px;
          border: 1px solid rgb(var(--text-color) / .12);
          border-radius: 10px;
          background: #fff;
          box-shadow: 0 10px 30px rgb(0 0 0 / .11);
        }

        .btsearch-sort__menu[hidden] {
          display: none !important;
        }

        .btsearch-sort__option {
          display: flex;
          width: 100%;
          min-height: 40px;
          padding: 8px 10px;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          border: 0;
          border-radius: 7px;
          background: transparent;
          color: rgb(var(--text-color));
          font: inherit;
          font-size: 12px;
          text-align: left;
          cursor: pointer;
        }

        .btsearch-sort__option:hover {
          background: rgb(var(--text-color) / .045);
        }

        .btsearch-sort__option.is-active {
          background: rgb(var(--text-color) / .065);
          font-weight: 600;
        }

        .btsearch-filter-empty {
          padding: 12px 8px;
          color: rgb(var(--text-color) / .5);
          font-size: 11px;
        }

        .btsearch-empty__clear {
          margin-top: 8px;
          min-height: 38px;
          padding: 8px 14px;
          border: 1px solid rgb(var(--text-color) / .18);
          border-radius: 8px;
          background: #fff;
          color: rgb(var(--text-color));
          font: inherit;
          font-size: 12px;
          cursor: pointer;
        }

        html.btsearch-filter-drawer-open,
        html.btsearch-filter-drawer-open body {
          overflow: hidden !important;
        }

        @media screen and (max-width: 699px) {

          .btsearch-mobile-sort {
            min-width: 0;
          }

          .btsearch-mobile-sort__toggle {
            width: 100%;
            border-radius: 0 8px 8px 0 !important;
            margin-left: -1px;
          }

          .btsearch-mobile-sort
          .btsearch-sort__menu {
            right: 0;
            left: auto;
            width: min(260px, calc(100vw - 24px));
          }
        }

      `;

      document.head.appendChild(
        style
      );
    }


    /* =======================================================
       EVENTOS
       ======================================================= */

    bindEvents() {

      this.input.addEventListener(
        'input',
        () => {

          this.toggleClear();

          this.runDebounced();

          this.trackDebounced();
        }
      );


      this.input.addEventListener(
        'focus',
        () => {

          if (
            this.config.predictiveEnabled &&
            this.input
              .value
              .trim()
              .length >=
              this.config.predictiveMinChars &&
            this.engine
          ) {

            this.renderPredictive();
          }
        }
      );


      this.input.addEventListener(
        'keydown',
        event =>
          this.onKeydown(event)
      );


      this.clearButton
        ?.addEventListener(
          'click',
          () => {

            this.input.value = '';

            this.currentQuery = '';

            this.baseResults = [];
            this.currentResults = [];

            this.currentPage = 1;

            this.resetFiltersState();

            this.toggleClear();

            this.closePredictive();
            this.closeSortDropdowns();
            this.closeFilterMenus();
            this.closeFilterDrawer();

            if (
              !this.isGlobalHeader()
            ) {
              this.renderEmptyState();
            }

            this.input.focus();

            if (
              !this.isGlobalHeader()
            ) {

              const url =
                new URL(
                  window.location.href
                );

              url.searchParams.delete('q');

              history.replaceState(
                {},
                '',
                url
              );
            }
          }
        );


      this.refreshButton
        ?.addEventListener(
          'click',
          async () => {

            if (!this.loader) {
              return;
            }

            this.refreshButton.disabled =
              true;

            this.setStatus(
              this.ui.loadingIndex,
              'loading'
            );

            try {

              await this.loader.clearCache();

              const loaded =
                await this.loader.load({
                  force:
                    true
                });

              const prepareStarted =
                perfNow();

              this.engine =
                new BTSearchEngine(
                  loaded.products,
                  loaded.collections,
                  loaded.dictionary,
                  this.config.locale
                );

              const prepareMs =
                elapsedSince(
                  prepareStarted
                );

              this.updateStats(
                loaded,
                prepareMs
              );

              this.setStatus(
                this.ui.indexUpdated,
                'ready'
              );

              if (
                this.input
                  .value
                  .trim()
              ) {

                this.runSearch({
                  predictive:
                    this.config.predictiveEnabled,
                  updateHistory:
                    false
                });
              }

            } catch (error) {

              console.error(
                '[BT Search]',
                error
              );

              this.showFatal(
                this.humanizeLoadError(
                  error
                )
              );

            } finally {

              this.refreshButton.disabled =
                false;
            }
          }
        );


      window.addEventListener(
        'bt-search:index-updated',
        event => {

          const detail =
            event.detail;

          if (
            !detail ||
            !this.loader ||
            detail.cacheKey !==
            this.loader.cacheKey ||
            !detail.result
          ) {
            return;
          }

          const loaded =
            detail.result;

          const prepareStarted =
            perfNow();

          this.engine =
            new BTSearchEngine(
              loaded.products,
              loaded.collections,
              loaded.dictionary,
              this.config.locale
            );

          const prepareMs =
            elapsedSince(
              prepareStarted
            );

          this.updateStats(
            loaded,
            prepareMs
          );

          this.setStatus(
            this.ui.backgroundUpdated,
            'ready'
          );

          if (
            this.input
              .value
              .trim()
          ) {

            this.runSearch({
              predictive:
                this.isGlobalHeader(),
              updateHistory:
                false,
              preserveFilters:
                true
            });
          }
        }
      );


      document.addEventListener(
        'click',
        event => {

          if (
            !this.root.contains(
              event.target
            )
          ) {
            this.closePredictive();
          }

          if (
            !event.target.closest(
              '[data-bt-sort]'
            )
          ) {
            this.closeSortDropdowns();
          }

          if (
            !event.target.closest(
              '[data-bt-filter]'
            )
          ) {
            this.closeFilterMenus();
          }
        }
      );


      window.addEventListener(
        'popstate',
        () => {

          /*
           * Solo la página de resultados responde al historial.
           * La barra global siempre empieza vacía.
           */

          if (
            this.isGlobalHeader()
          ) {
            return;
          }

          const query =
            new URL(
              window.location.href
            )
              .searchParams
              .get('q')
            ||
            '';

          this.input.value =
            query;

          this.toggleClear();

          this.resetFiltersState();

          if (
            this.engine &&
            query
          ) {

            this.runSearch({
              predictive:
                false,

              updateHistory:
                false
            });

          } else {

            this.baseResults = [];
            this.currentResults = [];

            this.renderEmptyState();
          }
        }
      );


      this.root.addEventListener(
        'click',
        event =>
          this.onRootClick(event)
      );


      this.root.addEventListener(
        'input',
        event =>
          this.onRootInput(event)
      );


      this.root.addEventListener(
        'change',
        event =>
          this.onRootChange(event)
      );
    }


    onKeydown(event) {

      if (
        event.key ===
        'Escape'
      ) {

        this.closePredictive();
        this.closeSortDropdowns();
        this.closeFilterMenus();

        if (
          this.isFilterDrawerOpen()
        ) {
          this.closeFilterDrawer();
        }

        return;
      }


      if (
        !this.config.predictiveEnabled
      ) {

        if (
          event.key ===
          'Enter'
        ) {

          event.preventDefault();

          this.runSearch({
            predictive:
              false,

            updateHistory:
              true
          });
        }

        return;
      }


      const options = [
        ...this.predictive
          .querySelectorAll(
            '[data-bt-predictive-option]'
          )
      ];


      if (
        event.key ===
        'ArrowDown' &&
        options.length
      ) {

        event.preventDefault();

        this.activePredictiveIndex =
          Math.min(
            this.activePredictiveIndex + 1,
            options.length - 1
          );

        this.updatePredictiveActive(
          options
        );

        return;
      }


      if (
        event.key ===
        'ArrowUp' &&
        options.length
      ) {

        event.preventDefault();

        this.activePredictiveIndex =
          Math.max(
            this.activePredictiveIndex - 1,
            0
          );

        this.updatePredictiveActive(
          options
        );

        return;
      }


      if (
        event.key ===
        'Enter'
      ) {

        /*
         * Si el usuario ha seleccionado un producto/colección
         * con las flechas, se abre esa opción directamente.
         */

        if (
          this.activePredictiveIndex >= 0 &&
          options[
            this.activePredictiveIndex
          ]
        ) {

          event.preventDefault();

          options[
            this.activePredictiveIndex
          ].click();

          return;
        }


        /*
         * NUEVO:
         * Enter desde la barra global abre la página completa.
         */

        if (
          this.isGlobalHeader()
        ) {

          const query =
            this.input
              .value
              .trim();

          if (
            query.length >=
            this.config.predictiveMinChars
          ) {

            event.preventDefault();

            this.goToSearchPage(
              query
            );
          }

          return;
        }


        event.preventDefault();

        this.runSearch({
          predictive:
            false,

          updateHistory:
            true
        });

        this.closePredictive();
      }
    }


    updatePredictiveActive(options) {

      options.forEach(
        (
          option,
          index
        ) => {

          const active =
            index ===
            this.activePredictiveIndex;

          option
            .classList
            .toggle(
              'is-active',
              active
            );

          option.setAttribute(
            'aria-selected',
            active
              ? 'true'
              : 'false'
          );
        }
      );

      options[
        this.activePredictiveIndex
      ]
        ?.scrollIntoView({
          block:
            'nearest'
        });
    }


    /* =======================================================
       EJECUTAR BÚSQUEDA
       ======================================================= */

    async runSearch({
      predictive = false,
      updateHistory = false,
      preserveFilters = false
    } = {}) {

      if (!this.engine) {
        return;
      }

      const query =
        this.input
          .value
          .trim();

      const queryChanged =
        query !==
        this.currentQuery;

      this.currentQuery =
        query;

      this.currentPage =
        1;


      if (!query) {

        this.baseResults = [];
        this.currentResults = [];

        this.resetFiltersState();

        this.closePredictive();

        if (
          !this.isGlobalHeader()
        ) {
          this.closeFilterDrawer();
          this.renderEmptyState();
        }

        return;
      }


      /*
       * En la barra global esperamos mínimo 2 caracteres
       * para evitar mostrar cientos de coincidencias al
       * introducir una sola letra.
       */

      if (
        this.isGlobalHeader() &&
        query.length <
        this.config.predictiveMinChars
      ) {

        this.baseResults = [];
        this.currentResults = [];

        this.closePredictive();

        return;
      }


      if (
        queryChanged &&
        !preserveFilters
      ) {
        this.resetFiltersState();
      }


      this.baseResults =
        this.engine.search(query);

      this.rebuildCurrentResults();


      /*
       * NUEVO:
       *
       * En la barra global no construimos:
       * - grid
       * - filtros
       * - ordenación
       * - paginación
       *
       * Solo el predictive.
       */

      if (
        this.isGlobalHeader()
      ) {

        if (
          predictive &&
          this.config.predictiveEnabled
        ) {
          this.renderPredictive();
        } else {
          this.closePredictive();
        }

        return;
      }


      this.renderCollections();

      this.renderResults();


      if (
        predictive &&
        this.config.predictiveEnabled
      ) {

        this.renderPredictive();

      } else {

        this.closePredictive();
      }


      if (updateHistory) {

        const url =
          new URL(
            window.location.href
          );

        url.searchParams.set(
          'q',
          query
        );

        history.pushState(
          {},
          '',
          url
        );
      }
    }


    /* =======================================================
       PREDICTIVE
       ======================================================= */

    renderPredictive() {

      if (
        !this.config.predictiveEnabled ||
        !this.engine ||
        !this.currentQuery
      ) {

        this.closePredictive();
        return;
      }

      if (
        this.currentQuery.length <
        this.config.predictiveMinChars
      ) {

        this.closePredictive();
        return;
      }

      const productResults =
        this.currentResults
          .slice(
            0,
            this.getPredictiveLimit()
          );

      const collectionResults =
        this.engine.searchCollections(
          this.currentQuery,
          3
        );

      if (
        !productResults.length &&
        !collectionResults.length
      ) {

        this.predictive.innerHTML = `

          <div class="btsearch-predictive__empty">

            ${this.ui.noPredictiveResults}
            “${escapeHtml(this.currentQuery)}”.

          </div>

        `;

        this.predictive.hidden =
          false;

        this.activePredictiveIndex =
          -1;

        return;
      }


      const collectionHtml =
        collectionResults.length
          ? `

            <div class="btsearch-predictive__group">

              <div class="btsearch-predictive__heading">
                ${this.ui.collections}
              </div>

              ${
                collectionResults
                  .map(
                    ({
                      collection
                    }) => `

                      <a
                        class="btsearch-predictive__collection"
                        href="${this.collectionUrl(collection.handle)}"
                        data-bt-predictive-option
                        data-bt-collection-click="${escapeHtml(collection.handle)}"
                        role="option"
                        aria-selected="false"
                      >

                        <span>
                          ${escapeHtml(collection.title)}
                        </span>

                        <span aria-hidden="true">
                          →
                        </span>

                      </a>

                    `
                  )
                  .join('')
              }

            </div>

          `
          : '';


      const productHtml =
        productResults.length
          ? `

            <div class="btsearch-predictive__group">

              <div class="btsearch-predictive__heading">
                ${this.ui.products}
              </div>

              ${
                productResults
                  .map(
                    (
                      result,
                      index
                    ) =>
                      this.renderPredictiveProduct(
                        result,
                        index
                      )
                  )
                  .join('')
              }

            </div>

          `
          : '';


      const total =
        this.currentResults.length;

      const resultWord =
        total === 1
          ? this.ui.resultSingular
          : this.ui.resultPlural;


      const allResultsHtml =
        total > 0
          ? `

            <button
              type="button"
              class="btsearch-predictive__all"
              data-bt-show-all
            >

              ${this.ui.show}
              ${total}
              ${resultWord}
              ${this.ui.forWord}
              «${escapeHtml(this.currentQuery)}»

            </button>

          `
          : '';


      /*
       * Colecciones PRIMERO.
       * Productos DESPUÉS.
       */

      this.predictive.innerHTML = `

        ${collectionHtml}

        ${productHtml}

        ${allResultsHtml}

      `;

      this.predictive.hidden =
        false;

      this.activePredictiveIndex =
        -1;
    }


    renderPredictiveProduct(
      result,
      index
    ) {

      const product =
        result.product;

      const image =
        product.image?.url
          ? `

            <img
              src="${escapeHtml(product.image.url)}"
              alt="${escapeHtml(product.image.altText || product.title)}"
              loading="lazy"
            >

          `
          : '';

      return `

        <a
          class="btsearch-predictive__product"
          href="${this.productUrl(product.handle)}"
          data-bt-predictive-option
          data-bt-result-click="${escapeHtml(product.handle)}"
          data-bt-position="${index + 1}"
          role="option"
          aria-selected="false"
        >

          <span class="btsearch-predictive__image">
            ${image}
          </span>

          <span class="btsearch-predictive__info">

            <span class="btsearch-predictive__vendor">
              ${escapeHtml(product.vendor)}
            </span>

            <span class="btsearch-predictive__title">
              ${escapeHtml(product.title)}
            </span>

            <span class="btsearch-predictive__price">
              ${this.priceHtml(product, true)}
            </span>

          </span>

          ${
            product.available
              ? ''
              : `
                <span class="btsearch-predictive__soldout">
                  ${this.ui.soldOut}
                </span>
              `
          }

        </a>

      `;
    }


    /* =======================================================
       COLECCIONES PÁGINA COMPLETA
       ======================================================= */

    renderCollections() {

      if (
        !this.collections
      ) {
        return;
      }

      const matches =
        this.engine.searchCollections(
          this.currentQuery
        );

      if (!matches.length) {

        this.collections.hidden =
          true;

        this.collections.innerHTML =
          '';

        return;
      }

      this.collections.hidden =
        false;

      this.collections.innerHTML = `

        <div class="btsearch-collections__label">
          ${this.ui.relatedCollections}
        </div>

        <div class="btsearch-collections__list">

          ${
            matches
              .map(
                ({
                  collection
                }) => `

                  <a
                    href="${this.collectionUrl(collection.handle)}"
                    class="btsearch-collection-pill"
                    data-bt-collection-click="${escapeHtml(collection.handle)}"
                  >
                    ${escapeHtml(collection.title)}
                  </a>

                `
              )
              .join('')
          }

        </div>

      `;
    }


    /* =======================================================
       RESULTADOS
       ======================================================= */

    renderResults() {

      if (
        this.isGlobalHeader() ||
        !this.results
      ) {
        return;
      }

      const baseTotal =
        this.baseResults.length;

      const total =
        this.currentResults.length;

      if (!baseTotal) {

        this.results.innerHTML = `

          <div class="btsearch-empty">

            <strong>
              ${this.ui.noProductsFor}
              “${escapeHtml(this.currentQuery)}”.
            </strong>

            <span>
              ${this.ui.tryGeneralSearch}
            </span>

          </div>

        `;

        if (this.pagination) {
          this.pagination.innerHTML = '';
        }

        this.capture(
          'bt_search_no_results',
          {
            query:
              this.currentQuery,

            surface:
              'results_page'
          }
        );

        return;
      }

      const pages =
        Math.max(
          1,
          Math.ceil(
            total /
            this.config.perPage
          )
        );

      this.currentPage =
        total
          ? Math.min(
              this.currentPage,
              pages
            )
          : 1;

      const start =
        (
          this.currentPage -
          1
        )
        *
        this.config.perPage;

      const pageResults =
        total
          ? this.currentResults
              .slice(
                start,
                start +
                this.config.perPage
              )
          : [];

      const resultsWord =
        total === 1
          ? this.ui.resultSingular
          : this.ui.resultPlural;

      const gridHtml =
        total
          ? `

            <div class="btsearch-grid">

              ${
                pageResults
                  .map(
                    (
                      result,
                      index
                    ) =>
                      this.renderProductCard(
                        result,
                        start + index
                      )
                  )
                  .join('')
              }

            </div>

          `
          : `

            <div class="btsearch-empty">

              <strong>
                ${this.ui.noFilteredProducts}
              </strong>

              <span>
                ${this.ui.tryRemoveFilters}
              </span>

              <button
                type="button"
                class="btsearch-empty__clear"
                data-bt-clear-filters
              >
                ${this.ui.clearFilters}
              </button>

            </div>

          `;

      this.results.innerHTML = `

        <div class="btsearch-results-head">

          <div class="btsearch-results-count">

            ${total}
            ${resultsWord}
            ${this.ui.forWord}

            <strong class="btsearch-results-query">
              ${escapeHtml(this.currentQuery)}
            </strong>

          </div>

          ${this.renderSortControl()}

        </div>

        ${this.renderMobileControls()}

        ${this.renderFilterBar()}

        ${this.renderActiveFilters()}

        ${gridHtml}

      `;

      this.renderPagination(
        total
          ? pages
          : 0
      );
    }


    /* =======================================================
       PRODUCT CARD
       ======================================================= */

    renderProductCard(
      result,
      absoluteIndex
    ) {

      const product =
        result.product;

      const productUrl =
        this.productUrl(
          product.handle
        );

      const primaryImage =
        product.image?.url
          ? `

            <img
              class="btsearch-card__image btsearch-card__image--primary"
              src="${escapeHtml(product.image.url)}"
              alt="${escapeHtml(product.image.altText || product.title)}"
              loading="lazy"
              width="480"
              height="480"
              draggable="false"
            >

          `
          : '';

      const secondaryImage =
        this.config.showSecondaryImage &&
        product.secondaryImage?.url
          ? `

            <img
              class="btsearch-card__image btsearch-card__image--secondary"
              src="${escapeHtml(product.secondaryImage.url)}"
              alt=""
              aria-hidden="true"
              loading="lazy"
              width="480"
              height="480"
              draggable="false"
            >

          `
          : '';

      const variantId =
        product.variant
          ?.numericId
        ||
        '';

      const canAdd =
        Boolean(
          this.config.showQuickBuy &&
          product.available &&
          product.variant
            ?.availableForSale &&
          variantId
        );

      const variantPrice =
        Number(
          product.variant
            ?.price
            ?.amount
        );

      const compareAtPrice =
        Number(
          product.variant
            ?.compareAtPrice
            ?.amount
        );

      const discountPercent =
        Number.isFinite(
          variantPrice
        )
        &&
        Number.isFinite(
          compareAtPrice
        )
        &&
        compareAtPrice >
        variantPrice
          ? Math.round(
              (
                1 -
                variantPrice /
                compareAtPrice
              )
              *
              100
            )
          : 0;

      const badges = [];

      if (!product.available) {

        badges.push(
          `
            <span class="btsearch-card__badge btsearch-card__badge--soldout">
              ${this.ui.soldOut}
            </span>
          `
        );
      }

      if (
        discountPercent > 0
      ) {

        badges.push(
          `
            <span class="btsearch-card__badge btsearch-card__badge--discount">
              -${discountPercent}%
            </span>
          `
        );
      }

      const badgeHtml =
        badges.length
          ? `
            <div class="btsearch-card__badge-list">
              ${badges.join('')}
            </div>
          `
          : '';

      const cartIcon = `

        <svg
          viewBox="0 0 24 24"
          width="19"
          height="19"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >

          <circle
            cx="9"
            cy="20"
            r="1"
          ></circle>

          <circle
            cx="19"
            cy="20"
            r="1"
          ></circle>

          <path
            d="M3 4h2l2.3 10.2a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 2-1.6L21 8H6"
          ></path>

        </svg>

      `;

      const quickBuyHtml =
        canAdd
          ? `

            <div class="btsearch-card__quick-buy">

              <button
                type="button"
                class="button btsearch-card__quick-add--desktop"
                data-bt-add="${variantId}"
                data-bt-handle="${escapeHtml(product.handle)}"
                data-bt-position="${absoluteIndex + 1}"
                aria-label="${escapeHtml(this.ui.addToCart)}: ${escapeHtml(product.title)}"
              >
                ${this.ui.addToCart}
              </button>

            </div>


            <button
              type="button"
              class="btsearch-card__quick-add-mobile"
              data-bt-add="${variantId}"
              data-bt-handle="${escapeHtml(product.handle)}"
              data-bt-position="${absoluteIndex + 1}"
              aria-label="${escapeHtml(this.ui.addToCart)}: ${escapeHtml(product.title)}"
            >
              ${cartIcon}
            </button>

          `
          : '';

      const vendorHtml =
        this.config.showVendor &&
        product.vendor
          ? `

            <a
              class="btsearch-card__vendor"
              href="${productUrl}"
              data-bt-result-click="${escapeHtml(product.handle)}"
              data-bt-position="${absoluteIndex + 1}"
              aria-label="${escapeHtml(this.ui.view)} ${escapeHtml(product.title)}"
            >
              ${escapeHtml(product.vendor)}
            </a>

          `
          : `

            <span
              class="btsearch-card__vendor btsearch-card__meta-spacer"
              aria-hidden="true"
            >
              &nbsp;
            </span>

          `;

      const ratingText =
        formatRatingValue(
          product.ratingValue
        );

      const hasRating =
        Boolean(
          this.config.showRating &&
          ratingText
        );

      const ratingHtml =
        hasRating
          ? `

            <a
              class="btsearch-card__rating"
              href="${productUrl}"
              data-bt-result-click="${escapeHtml(product.handle)}"
              data-bt-position="${absoluteIndex + 1}"
              aria-label="${escapeHtml(ratingText)} ${this.ui.outOfFive}${
                product.ratingCount
                  ? `, ${product.ratingCount} ${
                      product.ratingCount === 1
                        ? this.ui.reviewSingular
                        : this.ui.reviewPlural
                    }`
                  : ''
              }"
            >

              <span class="btsearch-card__rating-value">
                ${escapeHtml(ratingText)}
              </span>

              <span
                class="btsearch-card__rating-star"
                aria-hidden="true"
              >
                ★
              </span>

            </a>

          `
          : '';

      const activeIngredientHtml =
        product.activeIngredient
          ? `

            <p class="btsearch-card__active-ingredient">
              ${formatActiveIngredient(product.activeIngredient)}
            </p>

          `
          : `

            <p
              class="btsearch-card__active-ingredient is-empty"
              aria-hidden="true"
            >
              &nbsp;
            </p>

          `;

      const debug =
        this.config.debug
          ? `

            <details class="btsearch-debug">

              <summary>
                Score
                ${Math.round(result.score)}
                ·
                ${result.matchedConcepts}/${result.totalConcepts}
                conceptos
              </summary>

              <ul>

                ${
                  result.reasons
                    .map(
                      reason => `

                        <li>

                          <b>
                            +${reason.points}
                          </b>

                          <strong>
                            ${escapeHtml(reason.concept || '')}
                          </strong>

                          →

                          ${escapeHtml(reason.field)}
                          ·
                          ${escapeHtml(reason.type)}
                          ·
                          “${escapeHtml(reason.value)}”

                        </li>

                      `
                    )
                    .join('')
                }

              </ul>

            </details>

          `
          : '';

      return `

        <article
          class="btsearch-card ${
            product.available
              ? ''
              : 'is-soldout'
          } ${
            secondaryImage
              ? 'has-secondary-image'
              : ''
          }"
        >

          <div class="btsearch-card__figure">

            <a
              class="btsearch-card__media-link"
              href="${productUrl}"
              data-bt-result-click="${escapeHtml(product.handle)}"
              data-bt-position="${absoluteIndex + 1}"
              aria-label="${escapeHtml(product.title)}"
              draggable="false"
            >

              ${primaryImage}

              ${secondaryImage}

            </a>

            ${badgeHtml}

            ${quickBuyHtml}

          </div>


          <div class="btsearch-card__info">

            <div class="btsearch-card__meta-row">

              ${vendorHtml}

              ${ratingHtml}

            </div>


            <div class="btsearch-card__main-info">

              <span class="btsearch-card__title">

                <a
                  href="${productUrl}"
                  data-bt-result-click="${escapeHtml(product.handle)}"
                  data-bt-position="${absoluteIndex + 1}"
                  draggable="false"
                >
                  ${escapeHtml(product.title)}
                </a>

              </span>

              <div class="btsearch-card__price">
                ${this.priceHtml(product, false)}
              </div>

            </div>

            ${activeIngredientHtml}

            ${debug}

          </div>

        </article>

      `;
    }


    /* =======================================================
       PRECIO
       ======================================================= */

    priceHtml(
      product,
      compact
    ) {

      const price =
        product.minPrice
        ||
        product.variant
          ?.price;

      if (!price) {
        return '';
      }

      const compare =
        product.variant
          ?.compareAtPrice;

      const variantPrice =
        product.variant
          ?.price
        ||
        price;

      const hasCompare =
        compare
        &&
        variantPrice
        &&
        Number(compare.amount) >
        Number(variantPrice.amount);

      const currentPrice =
        formatMoney(
          variantPrice.amount,
          variantPrice.currencyCode
          ||
          this.config.currency,
          this.config.locale
        );

      if (compact) {

        return escapeHtml(
          currentPrice
        );
      }

      const unitPrice =
        product.variant
          ?.unitPrice;

      const unitPriceHtml =
        unitPrice
          ? `

            <span class="btsearch-card__unit-price">
              (${escapeHtml(
                formatMoney(
                  unitPrice.amount,
                  unitPrice.currencyCode
                  ||
                  this.config.currency,
                  this.config.locale
                )
              )} / ${escapeHtml(this.ui.perDose)})
            </span>

          `
          : '';

      if (!hasCompare) {

        return `

          <span class="btsearch-card__price-current">
            ${escapeHtml(currentPrice)}
          </span>

          ${unitPriceHtml}

        `;
      }

      return `

        <span class="btsearch-card__price-current is-sale">
          ${escapeHtml(currentPrice)}
        </span>

        <span class="btsearch-card__price-compare">
          ${escapeHtml(
            formatMoney(
              compare.amount,
              compare.currencyCode
              ||
              this.config.currency,
              this.config.locale
            )
          )}
        </span>

        ${unitPriceHtml}

      `;
    }


    /* =======================================================
       PAGINACIÓN
       ======================================================= */

    renderPagination(pages) {

      if (!this.pagination) {
        return;
      }

      if (pages <= 1) {

        this.pagination.innerHTML =
          '';

        return;
      }

      const buttons = [];
      const visiblePages = [];

      if (pages <= 9) {

        for (
          let page = 1;
          page <= pages;
          page++
        ) {
          visiblePages.push(page);
        }

      } else {

        const pageSet =
          new Set([
            1,
            pages,
            this.currentPage - 1,
            this.currentPage,
            this.currentPage + 1
          ]);

        if (
          this.currentPage <= 4
        ) {

          for (
            let page = 2;
            page <= 5;
            page++
          ) {
            pageSet.add(page);
          }
        }

        if (
          this.currentPage >=
          pages - 3
        ) {

          for (
            let page =
              Math.max(
                1,
                pages - 4
              );
            page < pages;
            page++
          ) {
            pageSet.add(page);
          }
        }

        const sortedPages = [
          ...pageSet
        ]
          .filter(
            page =>
              page >= 1 &&
              page <= pages
          )
          .sort(
            (a, b) =>
              a - b
          );

        for (
          let index = 0;
          index <
          sortedPages.length;
          index++
        ) {

          const page =
            sortedPages[index];

          const previousPage =
            sortedPages[
              index - 1
            ];

          if (
            index > 0 &&
            page -
            previousPage > 1
          ) {

            if (
              page -
              previousPage === 2
            ) {

              visiblePages.push(
                previousPage + 1
              );

            } else {

              visiblePages.push(
                'ellipsis'
              );
            }
          }

          visiblePages.push(page);
        }
      }

      if (
        this.currentPage > 1
      ) {

        buttons.push(`

          <button
            type="button"
            data-bt-page="${this.currentPage - 1}"
            aria-label="${escapeHtml(this.ui.previousPage)}"
          >
            ${this.ui.previous}
          </button>

        `);
      }

      for (
        const item
        of visiblePages
      ) {

        if (
          item ===
          'ellipsis'
        ) {

          buttons.push(`

            <span
              class="btsearch-pagination__ellipsis"
              aria-hidden="true"
            >
              …
            </span>

          `);

          continue;
        }

        buttons.push(`

          <button
            type="button"
            data-bt-page="${item}"
            aria-label="${escapeHtml(this.ui.goToPage)} ${item}"
            ${
              item ===
              this.currentPage
                ? `
                  aria-current="page"
                  class="is-current"
                `
                : ''
            }
          >
            ${item}
          </button>

        `);
      }

      if (
        this.currentPage < pages
      ) {

        buttons.push(`

          <button
            type="button"
            data-bt-page="${this.currentPage + 1}"
            aria-label="${escapeHtml(this.ui.nextPage)}"
          >
            ${this.ui.next}
          </button>

        `);
      }

      this.pagination.innerHTML =
        buttons.join('');
    }


    renderEmptyState() {

      /*
       * La barra global no necesita estado vacío visible.
       */

      if (
        this.isGlobalHeader()
      ) {

        this.closePredictive();
        return;
      }

      if (this.collections) {

        this.collections.hidden =
          true;

        this.collections.innerHTML =
          '';
      }

      if (this.results) {

        this.results.innerHTML = `

          <div class="btsearch-empty btsearch-empty--initial">

            <strong>
              ${this.ui.initialPrompt}
            </strong>

            <span>
              ${this.ui.examples}:
              ${this.ui.exampleTerms}
            </span>

          </div>

        `;
      }

      if (this.pagination) {
        this.pagination.innerHTML = '';
      }
    }


    /* =======================================================
       CLICS
       ======================================================= */

    async onRootClick(event) {

      const addButton =
        event.target.closest(
          '[data-bt-add]'
        );

      if (addButton) {

        event.preventDefault();
        event.stopPropagation();

        await this.addToCart(
          addButton
        );

        return;
      }


      const sortToggle =
        event.target.closest(
          '[data-bt-sort-toggle]'
        );

      if (sortToggle) {

        event.preventDefault();

        this.toggleSortDropdown(
          sortToggle
        );

        return;
      }


      const sortOption =
        event.target.closest(
          '[data-bt-sort-value]'
        );

      if (sortOption) {

        event.preventDefault();

        this.setSortMode(
          sortOption
            .dataset
            .btSortValue
        );

        return;
      }


      const filterToggle =
        event.target.closest(
          '[data-bt-filter-toggle]'
        );

      if (filterToggle) {

        event.preventDefault();

        this.toggleFilterMenu(
          filterToggle
        );

        return;
      }


      const filterOption =
        event.target.closest(
          '[data-bt-filter-option]'
        );

      if (
        filterOption &&
        !filterOption.disabled
      ) {

        event.preventDefault();

        this.toggleFilterValue(
          filterOption
            .dataset
            .filterKey,

          filterOption
            .dataset
            .filterValue
        );

        return;
      }


      const chip =
        event.target.closest(
          '[data-bt-filter-chip]'
        );

      if (chip) {

        event.preventDefault();

        this.clearFilter(
          chip
            .dataset
            .filterKey,

          chip
            .dataset
            .filterValue
          ||
          null
        );

        return;
      }


      const clearFilters =
        event.target.closest(
          '[data-bt-clear-filters]'
        );

      if (clearFilters) {

        event.preventDefault();

        this.clearAllFilters();

        return;
      }


      const drawerOpen =
        event.target.closest(
          '[data-bt-filter-drawer-open]'
        );

      if (drawerOpen) {

        event.preventDefault();

        this.openFilterDrawer();

        return;
      }


      const drawerClose =
        event.target.closest(
          '[data-bt-filter-drawer-close]'
        );

      if (drawerClose) {

        event.preventDefault();

        this.closeFilterDrawer();

        return;
      }


      const drawerApply =
        event.target.closest(
          '[data-bt-filter-drawer-apply]'
        );

      if (drawerApply) {

        event.preventDefault();

        this.closeFilterDrawer();

        this.results
          ?.scrollIntoView({
            behavior:
              'smooth',
            block:
              'start'
          });

        return;
      }


      if (
        event.target.closest(
          '[data-bt-filter-overlay]'
        )
      ) {

        this.closeFilterDrawer();
        return;
      }


      const accordionToggle =
        event.target.closest(
          '[data-bt-filter-accordion-toggle]'
        );

      if (accordionToggle) {

        event.preventDefault();

        const key =
          accordionToggle
            .dataset
            .btFilterAccordionToggle;

        if (
          this.openMobileFilterSections.has(
            key
          )
        ) {

          this.openMobileFilterSections.delete(
            key
          );

        } else {

          this.openMobileFilterSections.add(
            key
          );
        }

        this.renderFilterDrawer();

        return;
      }


      const showAll =
        event.target.closest(
          '[data-bt-show-all]'
        );

      if (showAll) {

        event.preventDefault();

        /*
         * NUEVO:
         * desde el header vamos a la página completa.
         */

        if (
          this.isGlobalHeader()
        ) {

          this.goToSearchPage(
            this.currentQuery
          );

          return;
        }

        this.closePredictive();

        this.runSearch({
          predictive:
            false,

          updateHistory:
            true
        });

        this.results
          ?.scrollIntoView({
            behavior:
              'smooth',
            block:
              'start'
          });

        return;
      }


      const pageButton =
        event.target.closest(
          '[data-bt-page]'
        );

      if (pageButton) {

        this.currentPage =
          Number(
            pageButton
              .dataset
              .btPage
            ||
            1
          );

        this.renderResults();

        this.results
          ?.scrollIntoView({
            behavior:
              'smooth',
            block:
              'start'
          });

        return;
      }


      const resultLink =
        event.target.closest(
          '[data-bt-result-click]'
        );

      if (resultLink) {

        this.capture(
          'bt_search_result_click',
          {
            query:
              this.currentQuery,

            product_handle:
              resultLink
                .dataset
                .btResultClick,

            position:
              Number(
                resultLink
                  .dataset
                  .btPosition
                ||
                0
              ),

            surface:
              resultLink.closest(
                '[data-bt-search-predictive]'
              )
                ? (
                    this.isGlobalHeader()
                      ? 'global_header_predictive'
                      : 'predictive'
                  )
                : 'results_page'
          }
        );
      }


      const collectionLink =
        event.target.closest(
          '[data-bt-collection-click]'
        );

      if (collectionLink) {

        this.capture(
          'bt_search_collection_click',
          {
            query:
              this.currentQuery,

            collection_handle:
              collectionLink
                .dataset
                .btCollectionClick,

            surface:
              collectionLink.closest(
                '[data-bt-search-predictive]'
              )
                ? (
                    this.isGlobalHeader()
                      ? 'global_header_predictive'
                      : 'predictive'
                  )
                : 'results_page'
          }
        );
      }
    }


    onRootInput(event) {

      const brandSearch =
        event.target.closest(
          '[data-bt-brand-search]'
        );

      if (brandSearch) {

        this.brandFilterSearch =
          brandSearch.value ||
          '';

        const container =
          brandSearch.closest(
            '.btsearch-filter__menu, .btsearch-filter-accordion__content'
          );

        const needle =
          normalizeText(
            this.brandFilterSearch
          );

        container
          ?.querySelectorAll(
            '[data-bt-filter-option][data-filter-key="vendor"]'
          )
          .forEach(
            option => {

              const label =
                normalizeText(
                  option
                    .querySelector(
                      '.btsearch-filter-option__label'
                    )
                    ?.textContent
                  ||
                  ''
                );

              option.hidden =
                Boolean(
                  needle &&
                  !label.includes(
                    needle
                  )
                );
            }
          );
      }
    }


    onRootChange(event) {

      const priceInput =
        event.target.closest(
          '[data-bt-price-field]'
        );

      if (priceInput) {

        this.setPriceFilter(
          priceInput
            .dataset
            .btPriceField,

          priceInput.value
        );
      }
    }


    /* =======================================================
       CARRITO
       ======================================================= */

    async addToCart(button) {

      if (button.disabled) {
        return;
      }

      const originalHtml =
        button.innerHTML;

      const isMobileQuickAdd =
        button
          .classList
          .contains(
            'btsearch-card__quick-add-mobile'
          );

      const setButtonState =
        state => {

          if (
            state ===
            'loading'
          ) {

            button.innerHTML =
              isMobileQuickAdd
                ? `

                  <svg
                    class="btsearch-card__loading-icon"
                    viewBox="0 0 24 24"
                    width="19"
                    height="19"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.8"
                    aria-hidden="true"
                  >

                    <circle
                      cx="12"
                      cy="12"
                      r="9"
                      stroke-opacity=".25"
                    ></circle>

                    <path
                      d="M21 12a9 9 0 0 0-9-9"
                    ></path>

                  </svg>

                `
                : this.ui.adding;

            return;
          }

          if (
            state ===
            'success'
          ) {

            button.innerHTML =
              isMobileQuickAdd
                ? `

                  <svg
                    viewBox="0 0 24 24"
                    width="19"
                    height="19"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path d="m5 12 4 4L19 6"></path>
                  </svg>

                `
                : this.ui.added;

            return;
          }

          if (
            state ===
            'error'
          ) {

            button.innerHTML =
              isMobileQuickAdd
                ? '!'
                : this.ui.addError;

            return;
          }

          button.innerHTML =
            originalHtml;
        };

      button.disabled =
        true;

      button.setAttribute(
        'aria-busy',
        'true'
      );

      setButtonState(
        'loading'
      );

      try {

        const response =
          await fetch(
            this.config.cartAddUrl,
            {
              method:
                'POST',

              headers: {
                'Content-Type':
                  'application/json',
                'Accept':
                  'application/json'
              },

              body:
                JSON.stringify({
                  items: [
                    {
                      id:
                        Number(
                          button
                            .dataset
                            .btAdd
                        ),

                      quantity:
                        1
                    }
                  ]
                })
            }
          );

        const json =
          await response
            .json()
            .catch(
              () => null
            );

        if (!response.ok) {

          throw new Error(
            json?.description
            ||
            this.ui.addFailed
          );
        }

        setButtonState(
          'success'
        );

        this.capture(
          'bt_search_add_to_cart',
          {
            query:
              this.currentQuery,

            product_handle:
              button
                .dataset
                .btHandle,

            variant_id:
              Number(
                button
                  .dataset
                  .btAdd
              ),

            position:
              Number(
                button
                  .dataset
                  .btPosition
                ||
                0
              ),

            surface:
              'results_page'
          }
        );

        document
          .documentElement
          .dispatchEvent(
            new CustomEvent(
              'cart:refresh',
              {
                bubbles: true
              }
            )
          );

        setTimeout(
          () => {

            setButtonState(
              'idle'
            );

            button.disabled =
              false;

            button.removeAttribute(
              'aria-busy'
            );
          },
          1800
        );

      } catch (error) {

        console.error(
          '[BT Search cart]',
          error
        );

        setButtonState(
          'error'
        );

        setTimeout(
          () => {

            setButtonState(
              'idle'
            );

            button.disabled =
              false;

            button.removeAttribute(
              'aria-busy'
            );
          },
          1800
        );
      }
    }


    /* =======================================================
       POSTHOG
       ======================================================= */

    trackSearch() {

      if (!this.engine) {
        return;
      }

      const query =
        this.input
          .value
          .trim();

      if (
        query.length <
        this.config.predictiveMinChars
      ) {
        return;
      }

      const normalized =
        normalizeText(query);

      if (
        normalized ===
        this.lastTrackedQuery
      ) {
        return;
      }

      this.lastTrackedQuery =
        normalized;

      const results =
        this.engine.search(
          query
        );

      const collections =
        this.engine.searchCollections(
          query
        );

      this.capture(
        'bt_search',
        {
          query,

          normalized_query:
            normalized,

          results_count:
            results.length,

          available_results_count:
            results
              .filter(
                result =>
                  result.product.available
              )
              .length,

          collection_results_count:
            collections.length,

          surface:
            this.isGlobalHeader()
              ? 'global_header'
              : 'results_page'
        }
      );
    }


    capture(
      event,
      properties
    ) {

      try {

        if (
          window.posthog &&
          typeof window
            .posthog
            .capture ===
            'function'
        ) {

          window
            .posthog
            .capture(
              event,
              properties
            );
        }

      } catch (_) {}
    }


    /* =======================================================
       DEBUG
       ======================================================= */

    updateStats(
      loaded,
      prepareMs
    ) {

      if (!this.stats) {
        return;
      }

      const count =
        loaded.products.length;

      const expected =
        this.config.expectedProducts;

      const mismatch =
        expected &&
        Math.abs(
          count -
          expected
        ) > 20;

      const membershipCount =
        loaded.products
          .reduce(
            (
              total,
              product
            ) =>
              total +
              (
                product.collections
                  ?.length ||
                0
              ),
            0
          );

      const collectionSearchTermsCount =
        loaded.collections
          .reduce(
            (
              total,
              collection
            ) =>
              total +
              (
                collection.searchTerms
                  ?.length ||
                0
              ),
            0
          );

      const timings =
        loaded.timings ||
        {};

      const network =
        loaded.lastNetworkTimings;

      let cacheLabel =
        'API · índice nuevo';

      if (loaded.fromCache) {

        cacheLabel =
          loaded.cacheState ===
            'fresh'
            ? `IndexedDB · caché fresca (${formatCacheAge(loaded.cacheAgeMs)})`
            : `IndexedDB · caché inmediata (${formatCacheAge(loaded.cacheAgeMs)}) · actualizando`;
      }

      this.stats.innerHTML = `

        <span>
          <b>${count}</b>
          productos indexados
        </span>

        <span>
          <b>${loaded.collections.length}</b>
          colecciones públicas
        </span>

        <span>
          <b>${membershipCount}</b>
          relaciones producto-colección
        </span>

        <span>
          <b>${collectionSearchTermsCount}</b>
          términos de búsqueda de colecciones
        </span>

        <span>
          ${cacheLabel}
        </span>

        <span>
          Apertura:
          <b>
            ${formatSeconds(timings.loadMs)}
          </b>
        </span>

        <span>
          Preparar motor:
          <b>
            ${formatSeconds(prepareMs)}
          </b>
        </span>

        ${
          Number.isFinite(
            timings.indexedDbReadMs
          )
            ? `
              <span>
                Leer IndexedDB:
                <b>
                  ${formatSeconds(timings.indexedDbReadMs)}
                </b>
              </span>
            `
            : ''
        }

        ${
          Number.isFinite(
            timings.indexedDbWriteMs
          )
            ? `
              <span>
                Guardar IndexedDB:
                <b>
                  ${formatSeconds(timings.indexedDbWriteMs)}
                </b>
              </span>
            `
            : ''
        }

        ${
          network
            ? `

              <span>
                API productos:
                <b>
                  ${formatSeconds(network.productsMs)}
                </b>
              </span>

              <span>
                API colecciones:
                <b>
                  ${formatSeconds(network.collectionsMs)}
                </b>
              </span>

              <span>
                Diccionario:
                <b>
                  ${formatSeconds(network.dictionaryMs)}
                </b>
              </span>

              <span>
                Unión colecciones:
                <b>
                  ${formatSeconds(network.attachMs)}
                </b>
              </span>

              <span>
                Total última API:
                <b>
                  ${formatSeconds(network.totalMs)}
                </b>
              </span>

            `
            : ''
        }

        ${
          loaded.cachePersisted ===
            false
            ? `
              <span class="is-warning">
                El índice no se ha podido guardar en IndexedDB.
              </span>
            `
            : ''
        }

        ${
          mismatch
            ? `
              <span class="is-warning">
                Esperábamos aprox. ${expected} productos.
              </span>
            `
            : ''
        }

      `;
    }


    toggleClear() {

      if (this.clearButton) {

        this.clearButton.hidden =
          !this.input.value;
      }
    }


    closePredictive() {

      if (!this.predictive) {
        return;
      }

      this.predictive.hidden =
        true;

      this.predictive.innerHTML =
        '';

      this.activePredictiveIndex =
        -1;
    }


    setStatus(
      message,
      state
    ) {

      if (!this.status) {
        return;
      }

      this.status.textContent =
        message;

      this.status.dataset.state =
        state ||
        '';
    }


    showFatal(message) {

      this.setStatus(
        this.ui.configError,
        'error'
      );

      if (
        this.isGlobalHeader()
      ) {

        console.error(
          '[BT Search]',
          message
        );

        return;
      }

      if (!this.results) {
        return;
      }

      this.results.innerHTML = `

        <div class="btsearch-error">

          <strong>
            ${this.ui.startupFailed}
          </strong>

          <span>
            ${escapeHtml(message)}
          </span>

        </div>

      `;
    }


    humanizeLoadError(error) {

      const message =
        error?.message ||
        String(error);

      if (
        /access|unauthorized|permission|401|403/i
          .test(message)
      ) {

        return (
          message +
          ` ${this.ui.checkToken}`
        );
      }

      if (
        /metafield/i
          .test(message)
      ) {

        return (
          message +
          ` ${this.ui.checkMetafields}`
        );
      }

      return message;
    }


    productUrl(handle) {

      const root =
        this.config
          .rootUrl
          .endsWith('/')
            ? this.config.rootUrl
            : `${this.config.rootUrl}/`;

      return (
        `${root}products/`
        +
        encodeURIComponent(handle)
      );
    }


    vendorUrl(vendor) {

      const root =
        this.config
          .rootUrl
          .endsWith('/')
            ? this.config.rootUrl
            : `${this.config.rootUrl}/`;

      return (
        `${root}collections/vendors?q=`
        +
        encodeURIComponent(vendor)
      );
    }


    collectionUrl(handle) {

      const root =
        this.config
          .rootUrl
          .endsWith('/')
            ? this.config.rootUrl
            : `${this.config.rootUrl}/`;

      return (
        `${root}collections/`
        +
        encodeURIComponent(handle)
      );
    }


    /* =======================================================
       ICONOS
       ======================================================= */

    chevronIcon() {

      return `

        <svg
          viewBox="0 0 12 8"
          width="12"
          height="8"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="m1 1.5 5 5 5-5"></path>
        </svg>

      `;
    }


    filterIcon() {

      return `

        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="M4 6h16"></path>
          <path d="M7 12h10"></path>
          <path d="M10 18h4"></path>
        </svg>

      `;
    }


    searchIcon() {

      return `

        <svg
          viewBox="0 0 24 24"
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="7"></circle>
          <path d="m20 20-3.5-3.5"></path>
        </svg>

      `;
    }


    checkIcon() {

      return `

        <svg
          viewBox="0 0 16 16"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path d="m3 8 3 3 7-7"></path>
        </svg>

      `;
    }


    closeIcon() {

      return `

        <svg
          viewBox="0 0 24 24"
          width="18"
          height="18"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          aria-hidden="true"
        >
          <path d="M7 7l10 10"></path>
          <path d="M17 7L7 17"></path>
        </svg>

      `;
    }
  }


  /* =========================================================
     BOOT
     ========================================================= */

  function bootSearchApps() {

    document
      .querySelectorAll(
        '[data-bt-search-app]'
      )
      .forEach(
        root => {

          if (
            root
              .dataset
              .btSearchBooted ===
            'true'
          ) {
            return;
          }

          root
            .dataset
            .btSearchBooted =
              'true';

          new BTSearchApp(
            root
          )
            .init();
        }
      );
  }


  /* =========================================================
     PRECARGA GLOBAL
     ========================================================= */

  function isLikelySearchIntent(target) {

    const element =
      target
        ?.closest
        ?.(
          'a, button, [role="button"], input'
        );

    if (!element) {
      return false;
    }

    const haystack = [

      element.getAttribute(
        'href'
      ),

      element.getAttribute(
        'aria-label'
      ),

      element.getAttribute(
        'title'
      ),

      element.getAttribute(
        'data-action'
      ),

      element.id,

      String(
        element.className ||
        ''
      )

    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    return (
      haystack.includes('search')
      ||
      haystack.includes('buscar')
      ||
      haystack.includes('buscador')
      ||
      haystack.includes('suche')
      ||
      haystack.includes('suchen')
    );
  }


  function scheduleGlobalPreload() {

    const config =
      window
        .BT_SEARCH_GLOBAL_CONFIG;

    if (
      !config ||
      !config.shopDomain ||
      !config.token ||
      !config.dictionaryUrl
    ) {
      return;
    }

    const pageLocale =
      document
        .querySelector(
          '[data-bt-search-app]'
        )
        ?.dataset
        ?.locale
      ||
      document
        .documentElement
        ?.lang
      ||
      'es';

    const preloadConfig = {
      ...config,
      locale:
        pageLocale
    };

    const loader =
      new StorefrontIndexLoader(
        preloadConfig
      );

    let started = false;

    const start =
      () => {

        if (started) {
          return;
        }

        started = true;

        loader
          .load()
          .catch(
            error =>
              console.warn(
                '[BT Search preload]',
                error
              )
          );
      };

    const onIntent =
      event => {

        if (
          isLikelySearchIntent(
            event.target
          )
        ) {
          start();
        }
      };

    document.addEventListener(
      'pointerover',
      onIntent,
      {
        passive: true
      }
    );

    document.addEventListener(
      'focusin',
      onIntent
    );

    document.addEventListener(
      'touchstart',
      onIntent,
      {
        passive: true
      }
    );

    setTimeout(
      start,
      500
    );
  }


  /* =========================================================
     ARRANQUE
     ========================================================= */

  cleanupLegacyLocalStorage();


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () => {

        bootSearchApps();

        scheduleGlobalPreload();
      },
      {
        once: true
      }
    );

  } else {

    bootSearchApps();

    scheduleGlobalPreload();
  }


  document.addEventListener(
    'shopify:section:load',
    bootSearchApps
  );

})();

